const DEFAULT_CSS = `
.tcpa-questionary-custom .btn, .tcpa-questionary-custom .tcpa-item-button {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .tcpa-questionary-custom .btn, .tcpa-questionary-custom .tcpa-item-button {
      transition: none; } }
  .tcpa-questionary-custom .btn:hover, .tcpa-questionary-custom .tcpa-item-button:hover {
    color: #212529;
    text-decoration: none; }
  .tcpa-questionary-custom .btn:focus, .tcpa-questionary-custom .tcpa-item-button:focus, .tcpa-questionary-custom .btn.focus, .tcpa-questionary-custom .focus.tcpa-item-button {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .tcpa-questionary-custom .btn.disabled, .tcpa-questionary-custom .disabled.tcpa-item-button, .tcpa-questionary-custom .btn:disabled, .tcpa-questionary-custom .tcpa-item-button:disabled {
    opacity: 0.65; }
  .tcpa-questionary-custom .btn:not(:disabled):not(.disabled), .tcpa-questionary-custom .tcpa-item-button:not(:disabled):not(.disabled) {
    cursor: pointer; }

.tcpa-questionary-custom a.btn.disabled, .tcpa-questionary-custom a.disabled.tcpa-item-button,
.tcpa-questionary-custom fieldset:disabled a.btn,
.tcpa-questionary-custom fieldset:disabled a.tcpa-item-button {
  pointer-events: none; }

.tcpa-questionary-custom .btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff; }
  .tcpa-questionary-custom .btn-primary:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc; }
  .tcpa-questionary-custom .btn-primary:focus, .tcpa-questionary-custom .btn-primary.focus {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5); }
  .tcpa-questionary-custom .btn-primary.disabled, .tcpa-questionary-custom .btn-primary:disabled {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .tcpa-questionary-custom .btn-primary:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-primary:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-primary.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf; }
    .tcpa-questionary-custom .btn-primary:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-primary:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-primary.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5); }

.tcpa-questionary-custom .btn-secondary, .tcpa-questionary-custom .tcpa-item-button {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d; }
  .tcpa-questionary-custom .btn-secondary:hover, .tcpa-questionary-custom .tcpa-item-button:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62; }
  .tcpa-questionary-custom .btn-secondary:focus, .tcpa-questionary-custom .tcpa-item-button:focus, .tcpa-questionary-custom .btn-secondary.focus, .tcpa-questionary-custom .focus.tcpa-item-button {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
    box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }
  .tcpa-questionary-custom .btn-secondary.disabled, .tcpa-questionary-custom .disabled.tcpa-item-button, .tcpa-questionary-custom .btn-secondary:disabled, .tcpa-questionary-custom .tcpa-item-button:disabled {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .tcpa-questionary-custom .btn-secondary:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .tcpa-item-button:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-secondary:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .tcpa-item-button:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-secondary.dropdown-toggle,
  .show > .tcpa-questionary-custom .dropdown-toggle.tcpa-item-button {
    color: #fff;
    background-color: #545b62;
    border-color: #4e555b; }
    .tcpa-questionary-custom .btn-secondary:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .tcpa-item-button:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-secondary:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .tcpa-item-button:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-secondary.dropdown-toggle:focus,
    .show > .tcpa-questionary-custom .dropdown-toggle.tcpa-item-button:focus {
      box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }

.tcpa-questionary-custom .btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745; }
  .tcpa-questionary-custom .btn-success:hover {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34; }
  .tcpa-questionary-custom .btn-success:focus, .tcpa-questionary-custom .btn-success.focus {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34;
    box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5); }
  .tcpa-questionary-custom .btn-success.disabled, .tcpa-questionary-custom .btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
  .tcpa-questionary-custom .btn-success:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-success:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-success.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #1e7e34;
    border-color: #1c7430; }
    .tcpa-questionary-custom .btn-success:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-success:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-success.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5); }

.tcpa-questionary-custom .btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8; }
  .tcpa-questionary-custom .btn-info:hover {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b; }
  .tcpa-questionary-custom .btn-info:focus, .tcpa-questionary-custom .btn-info.focus {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b;
    box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5); }
  .tcpa-questionary-custom .btn-info.disabled, .tcpa-questionary-custom .btn-info:disabled {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
  .tcpa-questionary-custom .btn-info:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-info:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-info.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #117a8b;
    border-color: #10707f; }
    .tcpa-questionary-custom .btn-info:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-info:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-info.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5); }

.tcpa-questionary-custom .btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107; }
  .tcpa-questionary-custom .btn-warning:hover {
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00; }
  .tcpa-questionary-custom .btn-warning:focus, .tcpa-questionary-custom .btn-warning.focus {
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00;
    box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5); }
  .tcpa-questionary-custom .btn-warning.disabled, .tcpa-questionary-custom .btn-warning:disabled {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
  .tcpa-questionary-custom .btn-warning:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-warning:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-warning.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-warning.dropdown-toggle {
    color: #212529;
    background-color: #d39e00;
    border-color: #c69500; }
    .tcpa-questionary-custom .btn-warning:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-warning:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-warning.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5); }

.tcpa-questionary-custom .btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545; }
  .tcpa-questionary-custom .btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130; }
  .tcpa-questionary-custom .btn-danger:focus, .tcpa-questionary-custom .btn-danger.focus {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
    box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5); }
  .tcpa-questionary-custom .btn-danger.disabled, .tcpa-questionary-custom .btn-danger:disabled {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
  .tcpa-questionary-custom .btn-danger:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-danger:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-danger.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #bd2130;
    border-color: #b21f2d; }
    .tcpa-questionary-custom .btn-danger:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-danger:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-danger.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5); }

.tcpa-questionary-custom .btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa; }
  .tcpa-questionary-custom .btn-light:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5; }
  .tcpa-questionary-custom .btn-light:focus, .tcpa-questionary-custom .btn-light.focus {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
    box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }
  .tcpa-questionary-custom .btn-light.disabled, .tcpa-questionary-custom .btn-light:disabled {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
  .tcpa-questionary-custom .btn-light:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-light:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-light.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-light.dropdown-toggle {
    color: #212529;
    background-color: #dae0e5;
    border-color: #d3d9df; }
    .tcpa-questionary-custom .btn-light:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-light:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-light.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }

.tcpa-questionary-custom .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40; }
  .tcpa-questionary-custom .btn-dark:hover {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124; }
  .tcpa-questionary-custom .btn-dark:focus, .tcpa-questionary-custom .btn-dark.focus {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124;
    box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }
  .tcpa-questionary-custom .btn-dark.disabled, .tcpa-questionary-custom .btn-dark:disabled {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .tcpa-questionary-custom .btn-dark:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-dark:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-dark.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #1d2124;
    border-color: #171a1d; }
    .tcpa-questionary-custom .btn-dark:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-dark:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-dark.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }

.tcpa-questionary-custom .btn-outline-primary {
  color: #007bff;
  border-color: #007bff; }
  .tcpa-questionary-custom .btn-outline-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .tcpa-questionary-custom .btn-outline-primary:focus, .tcpa-questionary-custom .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }
  .tcpa-questionary-custom .btn-outline-primary.disabled, .tcpa-questionary-custom .btn-outline-primary:disabled {
    color: #007bff;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-primary:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-primary:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-primary.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
    .tcpa-questionary-custom .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-primary.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }

.tcpa-questionary-custom .btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d; }
  .tcpa-questionary-custom .btn-outline-secondary:hover {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .tcpa-questionary-custom .btn-outline-secondary:focus, .tcpa-questionary-custom .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }
  .tcpa-questionary-custom .btn-outline-secondary.disabled, .tcpa-questionary-custom .btn-outline-secondary:disabled {
    color: #6c757d;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-secondary:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-secondary:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-secondary.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
    .tcpa-questionary-custom .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-secondary.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.tcpa-questionary-custom .btn-outline-success {
  color: #28a745;
  border-color: #28a745; }
  .tcpa-questionary-custom .btn-outline-success:hover {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
  .tcpa-questionary-custom .btn-outline-success:focus, .tcpa-questionary-custom .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }
  .tcpa-questionary-custom .btn-outline-success.disabled, .tcpa-questionary-custom .btn-outline-success:disabled {
    color: #28a745;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-success:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-success:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-success.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
    .tcpa-questionary-custom .btn-outline-success:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-success:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-success.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }

.tcpa-questionary-custom .btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8; }
  .tcpa-questionary-custom .btn-outline-info:hover {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
  .tcpa-questionary-custom .btn-outline-info:focus, .tcpa-questionary-custom .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }
  .tcpa-questionary-custom .btn-outline-info.disabled, .tcpa-questionary-custom .btn-outline-info:disabled {
    color: #17a2b8;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-info:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-info:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-info.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
    .tcpa-questionary-custom .btn-outline-info:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-info:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-info.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }

.tcpa-questionary-custom .btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107; }
  .tcpa-questionary-custom .btn-outline-warning:hover {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
  .tcpa-questionary-custom .btn-outline-warning:focus, .tcpa-questionary-custom .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }
  .tcpa-questionary-custom .btn-outline-warning.disabled, .tcpa-questionary-custom .btn-outline-warning:disabled {
    color: #ffc107;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-warning:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-warning:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-warning.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-warning.dropdown-toggle {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
    .tcpa-questionary-custom .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-warning.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }

.tcpa-questionary-custom .btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545; }
  .tcpa-questionary-custom .btn-outline-danger:hover {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
  .tcpa-questionary-custom .btn-outline-danger:focus, .tcpa-questionary-custom .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }
  .tcpa-questionary-custom .btn-outline-danger.disabled, .tcpa-questionary-custom .btn-outline-danger:disabled {
    color: #dc3545;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-danger:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-danger:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-danger.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
    .tcpa-questionary-custom .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-danger.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }

.tcpa-questionary-custom .btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa; }
  .tcpa-questionary-custom .btn-outline-light:hover {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
  .tcpa-questionary-custom .btn-outline-light:focus, .tcpa-questionary-custom .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }
  .tcpa-questionary-custom .btn-outline-light.disabled, .tcpa-questionary-custom .btn-outline-light:disabled {
    color: #f8f9fa;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-light:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-light:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-light.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-light.dropdown-toggle {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
    .tcpa-questionary-custom .btn-outline-light:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-light:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-light.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }

.tcpa-questionary-custom .btn-outline-dark {
  color: #343a40;
  border-color: #343a40; }
  .tcpa-questionary-custom .btn-outline-dark:hover {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .tcpa-questionary-custom .btn-outline-dark:focus, .tcpa-questionary-custom .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }
  .tcpa-questionary-custom .btn-outline-dark.disabled, .tcpa-questionary-custom .btn-outline-dark:disabled {
    color: #343a40;
    background-color: transparent; }
  .tcpa-questionary-custom .btn-outline-dark:not(:disabled):not(.disabled):active, .tcpa-questionary-custom .btn-outline-dark:not(:disabled):not(.disabled).active, .tcpa-questionary-custom .btn-outline-dark.tcpa-item-button.checked:not(:disabled):not(.disabled),
  .show > .tcpa-questionary-custom .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
    .tcpa-questionary-custom .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .tcpa-questionary-custom .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .tcpa-questionary-custom .btn-outline-dark.tcpa-item-button.checked:not(:disabled):not(.disabled):focus,
    .show > .tcpa-questionary-custom .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.tcpa-questionary-custom .btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none; }
  .tcpa-questionary-custom .btn-link:hover {
    color: #0056b3;
    text-decoration: underline; }
  .tcpa-questionary-custom .btn-link:focus, .tcpa-questionary-custom .btn-link.focus {
    text-decoration: underline; }
  .tcpa-questionary-custom .btn-link:disabled, .tcpa-questionary-custom .btn-link.disabled {
    color: #6c757d;
    pointer-events: none; }

.tcpa-questionary-custom .btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.tcpa-questionary-custom .btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.tcpa-questionary-custom .btn-block, .tcpa-questionary-custom .tcpa-item-button {
  display: block;
  width: 100%; }
  .tcpa-questionary-custom .btn-block + .btn-block, .tcpa-questionary-custom .tcpa-item-button + .btn-block, .tcpa-questionary-custom .btn-block + .tcpa-item-button, .tcpa-questionary-custom .tcpa-item-button + .tcpa-item-button {
    margin-top: 0.5rem; }

.tcpa-questionary-custom input[type="submit"].btn-block, .tcpa-questionary-custom input.tcpa-item-button[type="submit"],
.tcpa-questionary-custom input[type="reset"].btn-block,
.tcpa-questionary-custom input.tcpa-item-button[type="reset"],
.tcpa-questionary-custom input[type="button"].btn-block,
.tcpa-questionary-custom input.tcpa-item-button[type="button"] {
  width: 100%; }

.tcpa-questionary-custom .container, .tcpa-questionary-custom .tcpa-container,
.tcpa-questionary-custom .container-fluid,
.tcpa-questionary-custom .container-sm,
.tcpa-questionary-custom .container-md,
.tcpa-questionary-custom .container-lg,
.tcpa-questionary-custom .container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .tcpa-questionary-custom .container, .tcpa-questionary-custom .tcpa-container, .tcpa-questionary-custom .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .tcpa-questionary-custom .container, .tcpa-questionary-custom .tcpa-container, .tcpa-questionary-custom .container-sm, .tcpa-questionary-custom .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .tcpa-questionary-custom .container, .tcpa-questionary-custom .tcpa-container, .tcpa-questionary-custom .container-sm, .tcpa-questionary-custom .container-md, .tcpa-questionary-custom .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .tcpa-questionary-custom .container, .tcpa-questionary-custom .tcpa-container, .tcpa-questionary-custom .container-sm, .tcpa-questionary-custom .container-md, .tcpa-questionary-custom .container-lg, .tcpa-questionary-custom .container-xl {
    max-width: 1140px; } }

.tcpa-questionary-custom .row, .tcpa-questionary-custom .tcpa-dropdown-container, .tcpa-questionary-custom .tcpa-answers, .tcpa-questionary-custom .tcpa-answers .tcpa-answers-row, .tcpa-questionary-custom.tcpa-required.error .tcpa-required-feedback {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px; }

.tcpa-questionary-custom .no-gutters {
  margin-right: 0;
  margin-left: 0; }
  .tcpa-questionary-custom .no-gutters > .col, .tcpa-questionary-custom .no-gutters > .tcpa-col,
  .tcpa-questionary-custom .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0; }

.tcpa-questionary-custom .col-1, .tcpa-questionary-custom .col-2, .tcpa-questionary-custom .col-3, .tcpa-questionary-custom .col-4, .tcpa-questionary-custom .col-5, .tcpa-questionary-custom .col-6, .tcpa-questionary-custom .col-7, .tcpa-questionary-custom .col-8, .tcpa-questionary-custom .col-9, .tcpa-questionary-custom .col-10, .tcpa-questionary-custom .col-11, .tcpa-questionary-custom .col-12, .tcpa-questionary-custom .col, .tcpa-questionary-custom .tcpa-col,
.tcpa-questionary-custom .col-auto, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown-container, .tcpa-questionary-custom .col-sm-1, .tcpa-questionary-custom .col-sm-2, .tcpa-questionary-custom .col-sm-3, .tcpa-questionary-custom .col-sm-4, .tcpa-questionary-custom .col-sm-5, .tcpa-questionary-custom .col-sm-6, .tcpa-questionary-custom .col-sm-7, .tcpa-questionary-custom .col-sm-8, .tcpa-questionary-custom .col-sm-9, .tcpa-questionary-custom .col-sm-10, .tcpa-questionary-custom .col-sm-11, .tcpa-questionary-custom .col-sm-12, .tcpa-questionary-custom .col-sm,
.tcpa-questionary-custom .col-sm-auto, .tcpa-questionary-custom .col-md-1, .tcpa-questionary-custom .col-md-2, .tcpa-questionary-custom .col-md-3, .tcpa-questionary-custom .col-md-4, .tcpa-questionary-custom .col-md-5, .tcpa-questionary-custom .col-md-6, .tcpa-questionary-custom .col-md-7, .tcpa-questionary-custom .col-md-8, .tcpa-questionary-custom .col-md-9, .tcpa-questionary-custom .col-md-10, .tcpa-questionary-custom .col-md-11, .tcpa-questionary-custom .col-md-12, .tcpa-questionary-custom .col-md,
.tcpa-questionary-custom .col-md-auto, .tcpa-questionary-custom .col-lg-1, .tcpa-questionary-custom .col-lg-2, .tcpa-questionary-custom .col-lg-3, .tcpa-questionary-custom .col-lg-4, .tcpa-questionary-custom .col-lg-5, .tcpa-questionary-custom .col-lg-6, .tcpa-questionary-custom .col-lg-7, .tcpa-questionary-custom .col-lg-8, .tcpa-questionary-custom .col-lg-9, .tcpa-questionary-custom .col-lg-10, .tcpa-questionary-custom .col-lg-11, .tcpa-questionary-custom .col-lg-12, .tcpa-questionary-custom .col-lg,
.tcpa-questionary-custom .col-lg-auto, .tcpa-questionary-custom .col-xl-1, .tcpa-questionary-custom .col-xl-2, .tcpa-questionary-custom .col-xl-3, .tcpa-questionary-custom .col-xl-4, .tcpa-questionary-custom .col-xl-5, .tcpa-questionary-custom .col-xl-6, .tcpa-questionary-custom .col-xl-7, .tcpa-questionary-custom .col-xl-8, .tcpa-questionary-custom .col-xl-9, .tcpa-questionary-custom .col-xl-10, .tcpa-questionary-custom .col-xl-11, .tcpa-questionary-custom .col-xl-12, .tcpa-questionary-custom .col-xl,
.tcpa-questionary-custom .col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px; }

.tcpa-questionary-custom .col, .tcpa-questionary-custom .tcpa-col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%; }

.tcpa-questionary-custom .row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%; }

.tcpa-questionary-custom .row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%; }

.tcpa-questionary-custom .row-cols-3 > * {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.tcpa-questionary-custom .row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%; }

.tcpa-questionary-custom .row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%; }

.tcpa-questionary-custom .row-cols-6 > * {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.tcpa-questionary-custom .col-auto, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown-container {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%; }

.tcpa-questionary-custom .col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%; }

.tcpa-questionary-custom .col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.tcpa-questionary-custom .col-3 {
  flex: 0 0 25%;
  max-width: 25%; }

.tcpa-questionary-custom .col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.tcpa-questionary-custom .col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%; }

.tcpa-questionary-custom .col-6 {
  flex: 0 0 50%;
  max-width: 50%; }

.tcpa-questionary-custom .col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%; }

.tcpa-questionary-custom .col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%; }

.tcpa-questionary-custom .col-9 {
  flex: 0 0 75%;
  max-width: 75%; }

.tcpa-questionary-custom .col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%; }

.tcpa-questionary-custom .col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%; }

.tcpa-questionary-custom .col-12 {
  flex: 0 0 100%;
  max-width: 100%; }

.tcpa-questionary-custom .order-first {
  order: -1; }

.tcpa-questionary-custom .order-last {
  order: 13; }

.tcpa-questionary-custom .order-0 {
  order: 0; }

.tcpa-questionary-custom .order-1 {
  order: 1; }

.tcpa-questionary-custom .order-2 {
  order: 2; }

.tcpa-questionary-custom .order-3 {
  order: 3; }

.tcpa-questionary-custom .order-4 {
  order: 4; }

.tcpa-questionary-custom .order-5 {
  order: 5; }

.tcpa-questionary-custom .order-6 {
  order: 6; }

.tcpa-questionary-custom .order-7 {
  order: 7; }

.tcpa-questionary-custom .order-8 {
  order: 8; }

.tcpa-questionary-custom .order-9 {
  order: 9; }

.tcpa-questionary-custom .order-10 {
  order: 10; }

.tcpa-questionary-custom .order-11 {
  order: 11; }

.tcpa-questionary-custom .order-12 {
  order: 12; }

.tcpa-questionary-custom .offset-1 {
  margin-left: 8.33333%; }

.tcpa-questionary-custom .offset-2 {
  margin-left: 16.66667%; }

.tcpa-questionary-custom .offset-3 {
  margin-left: 25%; }

.tcpa-questionary-custom .offset-4 {
  margin-left: 33.33333%; }

.tcpa-questionary-custom .offset-5 {
  margin-left: 41.66667%; }

.tcpa-questionary-custom .offset-6 {
  margin-left: 50%; }

.tcpa-questionary-custom .offset-7 {
  margin-left: 58.33333%; }

.tcpa-questionary-custom .offset-8 {
  margin-left: 66.66667%; }

.tcpa-questionary-custom .offset-9 {
  margin-left: 75%; }

.tcpa-questionary-custom .offset-10 {
  margin-left: 83.33333%; }

.tcpa-questionary-custom .offset-11 {
  margin-left: 91.66667%; }

@media (min-width: 576px) {
  .tcpa-questionary-custom .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .row-cols-sm-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .tcpa-questionary-custom .row-cols-sm-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .tcpa-questionary-custom .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .tcpa-questionary-custom .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .tcpa-questionary-custom .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .tcpa-questionary-custom .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .tcpa-questionary-custom .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .tcpa-questionary-custom .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .tcpa-questionary-custom .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .tcpa-questionary-custom .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .order-sm-first {
    order: -1; }
  .tcpa-questionary-custom .order-sm-last {
    order: 13; }
  .tcpa-questionary-custom .order-sm-0 {
    order: 0; }
  .tcpa-questionary-custom .order-sm-1 {
    order: 1; }
  .tcpa-questionary-custom .order-sm-2 {
    order: 2; }
  .tcpa-questionary-custom .order-sm-3 {
    order: 3; }
  .tcpa-questionary-custom .order-sm-4 {
    order: 4; }
  .tcpa-questionary-custom .order-sm-5 {
    order: 5; }
  .tcpa-questionary-custom .order-sm-6 {
    order: 6; }
  .tcpa-questionary-custom .order-sm-7 {
    order: 7; }
  .tcpa-questionary-custom .order-sm-8 {
    order: 8; }
  .tcpa-questionary-custom .order-sm-9 {
    order: 9; }
  .tcpa-questionary-custom .order-sm-10 {
    order: 10; }
  .tcpa-questionary-custom .order-sm-11 {
    order: 11; }
  .tcpa-questionary-custom .order-sm-12 {
    order: 12; }
  .tcpa-questionary-custom .offset-sm-0 {
    margin-left: 0; }
  .tcpa-questionary-custom .offset-sm-1 {
    margin-left: 8.33333%; }
  .tcpa-questionary-custom .offset-sm-2 {
    margin-left: 16.66667%; }
  .tcpa-questionary-custom .offset-sm-3 {
    margin-left: 25%; }
  .tcpa-questionary-custom .offset-sm-4 {
    margin-left: 33.33333%; }
  .tcpa-questionary-custom .offset-sm-5 {
    margin-left: 41.66667%; }
  .tcpa-questionary-custom .offset-sm-6 {
    margin-left: 50%; }
  .tcpa-questionary-custom .offset-sm-7 {
    margin-left: 58.33333%; }
  .tcpa-questionary-custom .offset-sm-8 {
    margin-left: 66.66667%; }
  .tcpa-questionary-custom .offset-sm-9 {
    margin-left: 75%; }
  .tcpa-questionary-custom .offset-sm-10 {
    margin-left: 83.33333%; }
  .tcpa-questionary-custom .offset-sm-11 {
    margin-left: 91.66667%; } }

@media (min-width: 768px) {
  .tcpa-questionary-custom .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .row-cols-md-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .tcpa-questionary-custom .row-cols-md-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .tcpa-questionary-custom .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .tcpa-questionary-custom .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .tcpa-questionary-custom .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .tcpa-questionary-custom .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .tcpa-questionary-custom .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .tcpa-questionary-custom .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .tcpa-questionary-custom .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .tcpa-questionary-custom .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .order-md-first {
    order: -1; }
  .tcpa-questionary-custom .order-md-last {
    order: 13; }
  .tcpa-questionary-custom .order-md-0 {
    order: 0; }
  .tcpa-questionary-custom .order-md-1 {
    order: 1; }
  .tcpa-questionary-custom .order-md-2 {
    order: 2; }
  .tcpa-questionary-custom .order-md-3 {
    order: 3; }
  .tcpa-questionary-custom .order-md-4 {
    order: 4; }
  .tcpa-questionary-custom .order-md-5 {
    order: 5; }
  .tcpa-questionary-custom .order-md-6 {
    order: 6; }
  .tcpa-questionary-custom .order-md-7 {
    order: 7; }
  .tcpa-questionary-custom .order-md-8 {
    order: 8; }
  .tcpa-questionary-custom .order-md-9 {
    order: 9; }
  .tcpa-questionary-custom .order-md-10 {
    order: 10; }
  .tcpa-questionary-custom .order-md-11 {
    order: 11; }
  .tcpa-questionary-custom .order-md-12 {
    order: 12; }
  .tcpa-questionary-custom .offset-md-0 {
    margin-left: 0; }
  .tcpa-questionary-custom .offset-md-1 {
    margin-left: 8.33333%; }
  .tcpa-questionary-custom .offset-md-2 {
    margin-left: 16.66667%; }
  .tcpa-questionary-custom .offset-md-3 {
    margin-left: 25%; }
  .tcpa-questionary-custom .offset-md-4 {
    margin-left: 33.33333%; }
  .tcpa-questionary-custom .offset-md-5 {
    margin-left: 41.66667%; }
  .tcpa-questionary-custom .offset-md-6 {
    margin-left: 50%; }
  .tcpa-questionary-custom .offset-md-7 {
    margin-left: 58.33333%; }
  .tcpa-questionary-custom .offset-md-8 {
    margin-left: 66.66667%; }
  .tcpa-questionary-custom .offset-md-9 {
    margin-left: 75%; }
  .tcpa-questionary-custom .offset-md-10 {
    margin-left: 83.33333%; }
  .tcpa-questionary-custom .offset-md-11 {
    margin-left: 91.66667%; } }

@media (min-width: 992px) {
  .tcpa-questionary-custom .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .row-cols-lg-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .tcpa-questionary-custom .row-cols-lg-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .tcpa-questionary-custom .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .tcpa-questionary-custom .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .tcpa-questionary-custom .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .tcpa-questionary-custom .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .tcpa-questionary-custom .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .tcpa-questionary-custom .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .tcpa-questionary-custom .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .tcpa-questionary-custom .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .order-lg-first {
    order: -1; }
  .tcpa-questionary-custom .order-lg-last {
    order: 13; }
  .tcpa-questionary-custom .order-lg-0 {
    order: 0; }
  .tcpa-questionary-custom .order-lg-1 {
    order: 1; }
  .tcpa-questionary-custom .order-lg-2 {
    order: 2; }
  .tcpa-questionary-custom .order-lg-3 {
    order: 3; }
  .tcpa-questionary-custom .order-lg-4 {
    order: 4; }
  .tcpa-questionary-custom .order-lg-5 {
    order: 5; }
  .tcpa-questionary-custom .order-lg-6 {
    order: 6; }
  .tcpa-questionary-custom .order-lg-7 {
    order: 7; }
  .tcpa-questionary-custom .order-lg-8 {
    order: 8; }
  .tcpa-questionary-custom .order-lg-9 {
    order: 9; }
  .tcpa-questionary-custom .order-lg-10 {
    order: 10; }
  .tcpa-questionary-custom .order-lg-11 {
    order: 11; }
  .tcpa-questionary-custom .order-lg-12 {
    order: 12; }
  .tcpa-questionary-custom .offset-lg-0 {
    margin-left: 0; }
  .tcpa-questionary-custom .offset-lg-1 {
    margin-left: 8.33333%; }
  .tcpa-questionary-custom .offset-lg-2 {
    margin-left: 16.66667%; }
  .tcpa-questionary-custom .offset-lg-3 {
    margin-left: 25%; }
  .tcpa-questionary-custom .offset-lg-4 {
    margin-left: 33.33333%; }
  .tcpa-questionary-custom .offset-lg-5 {
    margin-left: 41.66667%; }
  .tcpa-questionary-custom .offset-lg-6 {
    margin-left: 50%; }
  .tcpa-questionary-custom .offset-lg-7 {
    margin-left: 58.33333%; }
  .tcpa-questionary-custom .offset-lg-8 {
    margin-left: 66.66667%; }
  .tcpa-questionary-custom .offset-lg-9 {
    margin-left: 75%; }
  .tcpa-questionary-custom .offset-lg-10 {
    margin-left: 83.33333%; }
  .tcpa-questionary-custom .offset-lg-11 {
    margin-left: 91.66667%; } }

@media (min-width: 1200px) {
  .tcpa-questionary-custom .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .row-cols-xl-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .tcpa-questionary-custom .row-cols-xl-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .tcpa-questionary-custom .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .tcpa-questionary-custom .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .tcpa-questionary-custom .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .tcpa-questionary-custom .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .tcpa-questionary-custom .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .tcpa-questionary-custom .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .tcpa-questionary-custom .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .tcpa-questionary-custom .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .tcpa-questionary-custom .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .tcpa-questionary-custom .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .tcpa-questionary-custom .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .tcpa-questionary-custom .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .tcpa-questionary-custom .order-xl-first {
    order: -1; }
  .tcpa-questionary-custom .order-xl-last {
    order: 13; }
  .tcpa-questionary-custom .order-xl-0 {
    order: 0; }
  .tcpa-questionary-custom .order-xl-1 {
    order: 1; }
  .tcpa-questionary-custom .order-xl-2 {
    order: 2; }
  .tcpa-questionary-custom .order-xl-3 {
    order: 3; }
  .tcpa-questionary-custom .order-xl-4 {
    order: 4; }
  .tcpa-questionary-custom .order-xl-5 {
    order: 5; }
  .tcpa-questionary-custom .order-xl-6 {
    order: 6; }
  .tcpa-questionary-custom .order-xl-7 {
    order: 7; }
  .tcpa-questionary-custom .order-xl-8 {
    order: 8; }
  .tcpa-questionary-custom .order-xl-9 {
    order: 9; }
  .tcpa-questionary-custom .order-xl-10 {
    order: 10; }
  .tcpa-questionary-custom .order-xl-11 {
    order: 11; }
  .tcpa-questionary-custom .order-xl-12 {
    order: 12; }
  .tcpa-questionary-custom .offset-xl-0 {
    margin-left: 0; }
  .tcpa-questionary-custom .offset-xl-1 {
    margin-left: 8.33333%; }
  .tcpa-questionary-custom .offset-xl-2 {
    margin-left: 16.66667%; }
  .tcpa-questionary-custom .offset-xl-3 {
    margin-left: 25%; }
  .tcpa-questionary-custom .offset-xl-4 {
    margin-left: 33.33333%; }
  .tcpa-questionary-custom .offset-xl-5 {
    margin-left: 41.66667%; }
  .tcpa-questionary-custom .offset-xl-6 {
    margin-left: 50%; }
  .tcpa-questionary-custom .offset-xl-7 {
    margin-left: 58.33333%; }
  .tcpa-questionary-custom .offset-xl-8 {
    margin-left: 66.66667%; }
  .tcpa-questionary-custom .offset-xl-9 {
    margin-left: 75%; }
  .tcpa-questionary-custom .offset-xl-10 {
    margin-left: 83.33333%; }
  .tcpa-questionary-custom .offset-xl-11 {
    margin-left: 91.66667%; } }

.tcpa-questionary-custom .form-control, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .tcpa-questionary-custom .form-control, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown {
      transition: none; } }
  .tcpa-questionary-custom .form-control::-ms-expand, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown::-ms-expand {
    background-color: transparent;
    border: 0; }
  .tcpa-questionary-custom .form-control:focus, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .tcpa-questionary-custom .form-control::placeholder, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown::placeholder {
    color: #6c757d;
    opacity: 1; }
  .tcpa-questionary-custom .form-control:disabled, .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown:disabled, .tcpa-questionary-custom .form-control[readonly], .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown[readonly] {
    background-color: #e9ecef;
    opacity: 1; }

.tcpa-questionary-custom input[type="date"].form-control, .tcpa-questionary-custom .tcpa-dropdown-container input.tcpa-dropdown[type="date"],
.tcpa-questionary-custom input[type="time"].form-control,
.tcpa-questionary-custom .tcpa-dropdown-container input.tcpa-dropdown[type="time"],
.tcpa-questionary-custom input[type="datetime-local"].form-control,
.tcpa-questionary-custom .tcpa-dropdown-container input.tcpa-dropdown[type="datetime-local"],
.tcpa-questionary-custom input[type="month"].form-control,
.tcpa-questionary-custom .tcpa-dropdown-container input.tcpa-dropdown[type="month"] {
  appearance: none; }

.tcpa-questionary-custom select.form-control:-moz-focusring, .tcpa-questionary-custom .tcpa-dropdown-container select.tcpa-dropdown:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057; }

.tcpa-questionary-custom select.form-control:focus::-ms-value, .tcpa-questionary-custom .tcpa-dropdown-container select.tcpa-dropdown:focus::-ms-value {
  color: #495057;
  background-color: #fff; }

.tcpa-questionary-custom .form-control-file,
.tcpa-questionary-custom .form-control-range {
  display: block;
  width: 100%; }

.tcpa-questionary-custom .col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.tcpa-questionary-custom .col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5; }

.tcpa-questionary-custom .col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5; }

.tcpa-questionary-custom .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .tcpa-questionary-custom .form-control-plaintext.form-control-sm, .tcpa-questionary-custom .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.tcpa-questionary-custom .form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.tcpa-questionary-custom .form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.tcpa-questionary-custom select.form-control[size], .tcpa-questionary-custom .tcpa-dropdown-container select.tcpa-dropdown[size], .tcpa-questionary-custom select.form-control[multiple], .tcpa-questionary-custom .tcpa-dropdown-container select.tcpa-dropdown[multiple] {
  height: auto; }

.tcpa-questionary-custom textarea.form-control, .tcpa-questionary-custom .tcpa-dropdown-container textarea.tcpa-dropdown {
  height: auto; }

.tcpa-questionary-custom .form-group {
  margin-bottom: 1rem; }

.tcpa-questionary-custom .form-text {
  display: block;
  margin-top: 0.25rem; }

.tcpa-questionary-custom .form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px; }
  .tcpa-questionary-custom .form-row > .col, .tcpa-questionary-custom .form-row > .tcpa-col,
  .tcpa-questionary-custom .form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px; }

.tcpa-questionary-custom .form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem; }

.tcpa-questionary-custom .form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem; }
  .tcpa-questionary-custom .form-check-input[disabled] ~ .form-check-label,
  .tcpa-questionary-custom .form-check-input:disabled ~ .form-check-label {
    color: #6c757d; }

.tcpa-questionary-custom .form-check-label {
  margin-bottom: 0; }

.tcpa-questionary-custom .form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem; }
  .tcpa-questionary-custom .form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: 0.3125rem;
    margin-left: 0; }

.tcpa-questionary-custom .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #28a745; }

.tcpa-questionary-custom .valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem; }
  .form-row > .col > .tcpa-questionary-custom .valid-tooltip, .tcpa-questionary-custom .form-row > .tcpa-col > .tcpa-questionary-custom .valid-tooltip,
  .form-row > [class*="col-"] > .tcpa-questionary-custom .valid-tooltip {
    left: 5px; }

.was-validated .tcpa-questionary-custom:valid ~ .valid-feedback,
.was-validated .tcpa-questionary-custom:valid ~ .valid-tooltip, .tcpa-questionary-custom.is-valid ~ .valid-feedback,
.tcpa-questionary-custom.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .tcpa-questionary-custom .form-control:valid, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown:valid, .tcpa-questionary-custom .form-control.is-valid, .tcpa-questionary-custom .tcpa-dropdown-container .is-valid.tcpa-dropdown {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .tcpa-questionary-custom .form-control:valid:focus, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown:valid:focus, .tcpa-questionary-custom .form-control.is-valid:focus, .tcpa-questionary-custom .tcpa-dropdown-container .is-valid.tcpa-dropdown:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .tcpa-questionary-custom select.form-control:valid, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container select.tcpa-dropdown:valid, .tcpa-questionary-custom select.form-control.is-valid, .tcpa-questionary-custom .tcpa-dropdown-container select.is-valid.tcpa-dropdown {
  padding-right: 3rem !important;
  background-position: right 1.5rem center; }

.was-validated .tcpa-questionary-custom textarea.form-control:valid, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container textarea.tcpa-dropdown:valid, .tcpa-questionary-custom textarea.form-control.is-valid, .tcpa-questionary-custom .tcpa-dropdown-container textarea.is-valid.tcpa-dropdown {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .tcpa-questionary-custom .custom-select:valid, .tcpa-questionary-custom .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat; }
  .was-validated .tcpa-questionary-custom .custom-select:valid:focus, .tcpa-questionary-custom .custom-select.is-valid:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .tcpa-questionary-custom .form-check-input:valid ~ .form-check-label, .tcpa-questionary-custom .form-check-input.is-valid ~ .form-check-label {
  color: #28a745; }

.was-validated .tcpa-questionary-custom .form-check-input:valid ~ .valid-feedback,
.was-validated .tcpa-questionary-custom .form-check-input:valid ~ .valid-tooltip, .tcpa-questionary-custom .form-check-input.is-valid ~ .valid-feedback,
.tcpa-questionary-custom .form-check-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .tcpa-questionary-custom .custom-control-input:valid ~ .custom-control-label, .tcpa-questionary-custom .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745; }
  .was-validated .tcpa-questionary-custom .custom-control-input:valid ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-valid ~ .custom-control-label::before {
    border-color: #28a745; }

.was-validated .tcpa-questionary-custom .custom-control-input:valid:checked ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57; }

.was-validated .tcpa-questionary-custom .custom-control-input:valid:focus ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .tcpa-questionary-custom .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745; }

.was-validated .tcpa-questionary-custom .custom-file-input:valid ~ .custom-file-label, .tcpa-questionary-custom .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745; }

.was-validated .tcpa-questionary-custom .custom-file-input:valid:focus ~ .custom-file-label, .tcpa-questionary-custom .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.tcpa-questionary-custom .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545; }

.tcpa-questionary-custom .invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem; }
  .form-row > .col > .tcpa-questionary-custom .invalid-tooltip, .tcpa-questionary-custom .form-row > .tcpa-col > .tcpa-questionary-custom .invalid-tooltip,
  .form-row > [class*="col-"] > .tcpa-questionary-custom .invalid-tooltip {
    left: 5px; }

.was-validated .tcpa-questionary-custom:invalid ~ .invalid-feedback,
.was-validated .tcpa-questionary-custom:invalid ~ .invalid-tooltip, .tcpa-questionary-custom.is-invalid ~ .invalid-feedback,
.tcpa-questionary-custom.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .tcpa-questionary-custom .form-control:invalid, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown:invalid, .tcpa-questionary-custom .form-control.is-invalid, .tcpa-questionary-custom .tcpa-dropdown-container .is-invalid.tcpa-dropdown {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .tcpa-questionary-custom .form-control:invalid:focus, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container .tcpa-dropdown:invalid:focus, .tcpa-questionary-custom .form-control.is-invalid:focus, .tcpa-questionary-custom .tcpa-dropdown-container .is-invalid.tcpa-dropdown:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .tcpa-questionary-custom select.form-control:invalid, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container select.tcpa-dropdown:invalid, .tcpa-questionary-custom select.form-control.is-invalid, .tcpa-questionary-custom .tcpa-dropdown-container select.is-invalid.tcpa-dropdown {
  padding-right: 3rem !important;
  background-position: right 1.5rem center; }

.was-validated .tcpa-questionary-custom textarea.form-control:invalid, .was-validated .tcpa-questionary-custom .tcpa-dropdown-container textarea.tcpa-dropdown:invalid, .tcpa-questionary-custom textarea.form-control.is-invalid, .tcpa-questionary-custom .tcpa-dropdown-container textarea.is-invalid.tcpa-dropdown {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .tcpa-questionary-custom .custom-select:invalid, .tcpa-questionary-custom .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat; }
  .was-validated .tcpa-questionary-custom .custom-select:invalid:focus, .tcpa-questionary-custom .custom-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .tcpa-questionary-custom .form-check-input:invalid ~ .form-check-label, .tcpa-questionary-custom .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545; }

.was-validated .tcpa-questionary-custom .form-check-input:invalid ~ .invalid-feedback,
.was-validated .tcpa-questionary-custom .form-check-input:invalid ~ .invalid-tooltip, .tcpa-questionary-custom .form-check-input.is-invalid ~ .invalid-feedback,
.tcpa-questionary-custom .form-check-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .tcpa-questionary-custom .custom-control-input:invalid ~ .custom-control-label, .tcpa-questionary-custom .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545; }
  .was-validated .tcpa-questionary-custom .custom-control-input:invalid ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #dc3545; }

.was-validated .tcpa-questionary-custom .custom-control-input:invalid:checked ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d; }

.was-validated .tcpa-questionary-custom .custom-control-input:invalid:focus ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .tcpa-questionary-custom .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .tcpa-questionary-custom .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545; }

.was-validated .tcpa-questionary-custom .custom-file-input:invalid ~ .custom-file-label, .tcpa-questionary-custom .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545; }

.was-validated .tcpa-questionary-custom .custom-file-input:invalid:focus ~ .custom-file-label, .tcpa-questionary-custom .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.tcpa-questionary-custom .form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center; }
  .tcpa-questionary-custom .form-inline .form-check {
    width: 100%; }
  @media (min-width: 576px) {
    .tcpa-questionary-custom .form-inline label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0; }
    .tcpa-questionary-custom .form-inline .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0; }
    .tcpa-questionary-custom .form-inline .form-control, .tcpa-questionary-custom .form-inline .tcpa-dropdown-container .tcpa-dropdown, .tcpa-questionary-custom .tcpa-dropdown-container .form-inline .tcpa-dropdown {
      display: inline-block;
      width: auto;
      vertical-align: middle; }
    .tcpa-questionary-custom .form-inline .form-control-plaintext {
      display: inline-block; }
    .tcpa-questionary-custom .form-inline .input-group,
    .tcpa-questionary-custom .form-inline .custom-select {
      width: auto; }
    .tcpa-questionary-custom .form-inline .form-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      padding-left: 0; }
    .tcpa-questionary-custom .form-inline .form-check-input {
      position: relative;
      flex-shrink: 0;
      margin-top: 0;
      margin-right: 0.25rem;
      margin-left: 0; }
    .tcpa-questionary-custom .form-inline .custom-control {
      align-items: center;
      justify-content: center; }
    .tcpa-questionary-custom .form-inline .custom-control-label {
      margin-bottom: 0; } }

.tcpa-questionary-custom .text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important; }

.tcpa-questionary-custom .text-justify {
  text-align: justify !important; }

.tcpa-questionary-custom .text-wrap {
  white-space: normal !important; }

.tcpa-questionary-custom .text-nowrap {
  white-space: nowrap !important; }

.tcpa-questionary-custom .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.tcpa-questionary-custom .text-left {
  text-align: left !important; }

.tcpa-questionary-custom .text-right {
  text-align: right !important; }

.tcpa-questionary-custom .text-center, .tcpa-questionary-custom .tcpa-title, .tcpa-questionary-custom .tcpa-consent-text {
  text-align: center !important; }

@media (min-width: 576px) {
  .tcpa-questionary-custom .text-sm-left {
    text-align: left !important; }
  .tcpa-questionary-custom .text-sm-right {
    text-align: right !important; }
  .tcpa-questionary-custom .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .tcpa-questionary-custom .text-md-left {
    text-align: left !important; }
  .tcpa-questionary-custom .text-md-right {
    text-align: right !important; }
  .tcpa-questionary-custom .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .tcpa-questionary-custom .text-lg-left {
    text-align: left !important; }
  .tcpa-questionary-custom .text-lg-right {
    text-align: right !important; }
  .tcpa-questionary-custom .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .tcpa-questionary-custom .text-xl-left {
    text-align: left !important; }
  .tcpa-questionary-custom .text-xl-right {
    text-align: right !important; }
  .tcpa-questionary-custom .text-xl-center {
    text-align: center !important; } }

.tcpa-questionary-custom .text-lowercase {
  text-transform: lowercase !important; }

.tcpa-questionary-custom .text-uppercase {
  text-transform: uppercase !important; }

.tcpa-questionary-custom .text-capitalize {
  text-transform: capitalize !important; }

.tcpa-questionary-custom .font-weight-light {
  font-weight: 300 !important; }

.tcpa-questionary-custom .font-weight-lighter {
  font-weight: lighter !important; }

.tcpa-questionary-custom .font-weight-normal {
  font-weight: 400 !important; }

.tcpa-questionary-custom .font-weight-bold {
  font-weight: 700 !important; }

.tcpa-questionary-custom .font-weight-bolder {
  font-weight: bolder !important; }

.tcpa-questionary-custom .font-italic {
  font-style: italic !important; }

.tcpa-questionary-custom .text-white {
  color: #fff !important; }

.tcpa-questionary-custom .text-primary {
  color: #007bff !important; }

.tcpa-questionary-custom a.text-primary:hover, .tcpa-questionary-custom a.text-primary:focus {
  color: #0056b3 !important; }

.tcpa-questionary-custom .text-secondary {
  color: #6c757d !important; }

.tcpa-questionary-custom a.text-secondary:hover, .tcpa-questionary-custom a.text-secondary:focus {
  color: #494f54 !important; }

.tcpa-questionary-custom .text-success {
  color: #28a745 !important; }

.tcpa-questionary-custom a.text-success:hover, .tcpa-questionary-custom a.text-success:focus {
  color: #19692c !important; }

.tcpa-questionary-custom .text-info {
  color: #17a2b8 !important; }

.tcpa-questionary-custom a.text-info:hover, .tcpa-questionary-custom a.text-info:focus {
  color: #0f6674 !important; }

.tcpa-questionary-custom .text-warning {
  color: #ffc107 !important; }

.tcpa-questionary-custom a.text-warning:hover, .tcpa-questionary-custom a.text-warning:focus {
  color: #ba8b00 !important; }

.tcpa-questionary-custom .text-danger {
  color: #dc3545 !important; }

.tcpa-questionary-custom a.text-danger:hover, .tcpa-questionary-custom a.text-danger:focus {
  color: #a71d2a !important; }

.tcpa-questionary-custom .text-light {
  color: #f8f9fa !important; }

.tcpa-questionary-custom a.text-light:hover, .tcpa-questionary-custom a.text-light:focus {
  color: #cbd3da !important; }

.tcpa-questionary-custom .text-dark {
  color: #343a40 !important; }

.tcpa-questionary-custom a.text-dark:hover, .tcpa-questionary-custom a.text-dark:focus {
  color: #121416 !important; }

.tcpa-questionary-custom .text-body {
  color: #212529 !important; }

.tcpa-questionary-custom .text-muted {
  color: #6c757d !important; }

.tcpa-questionary-custom .text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important; }

.tcpa-questionary-custom .text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important; }

.tcpa-questionary-custom .text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.tcpa-questionary-custom .text-decoration-none {
  text-decoration: none !important; }

.tcpa-questionary-custom .text-break {
  word-break: break-word !important;
  word-wrap: break-word !important; }

.tcpa-questionary-custom .text-reset {
  color: inherit !important; }

.tcpa-questionary-custom .d-none {
  display: none !important; }

.tcpa-questionary-custom .d-inline {
  display: inline !important; }

.tcpa-questionary-custom .d-inline-block {
  display: inline-block !important; }

.tcpa-questionary-custom .d-block {
  display: block !important; }

.tcpa-questionary-custom .d-table {
  display: table !important; }

.tcpa-questionary-custom .d-table-row {
  display: table-row !important; }

.tcpa-questionary-custom .d-table-cell {
  display: table-cell !important; }

.tcpa-questionary-custom .d-flex, .tcpa-questionary-custom .tcpa-item-button, .tcpa-questionary-custom .tcpa-dropdown-container, .tcpa-questionary-custom .tcpa-answers, .tcpa-questionary-custom.tcpa-required.error .tcpa-required-feedback {
  display: flex !important; }

.tcpa-questionary-custom .d-inline-flex {
  display: inline-flex !important; }

@media (min-width: 576px) {
  .tcpa-questionary-custom .d-sm-none {
    display: none !important; }
  .tcpa-questionary-custom .d-sm-inline {
    display: inline !important; }
  .tcpa-questionary-custom .d-sm-inline-block {
    display: inline-block !important; }
  .tcpa-questionary-custom .d-sm-block {
    display: block !important; }
  .tcpa-questionary-custom .d-sm-table {
    display: table !important; }
  .tcpa-questionary-custom .d-sm-table-row {
    display: table-row !important; }
  .tcpa-questionary-custom .d-sm-table-cell {
    display: table-cell !important; }
  .tcpa-questionary-custom .d-sm-flex {
    display: flex !important; }
  .tcpa-questionary-custom .d-sm-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 768px) {
  .tcpa-questionary-custom .d-md-none {
    display: none !important; }
  .tcpa-questionary-custom .d-md-inline {
    display: inline !important; }
  .tcpa-questionary-custom .d-md-inline-block {
    display: inline-block !important; }
  .tcpa-questionary-custom .d-md-block {
    display: block !important; }
  .tcpa-questionary-custom .d-md-table {
    display: table !important; }
  .tcpa-questionary-custom .d-md-table-row {
    display: table-row !important; }
  .tcpa-questionary-custom .d-md-table-cell {
    display: table-cell !important; }
  .tcpa-questionary-custom .d-md-flex {
    display: flex !important; }
  .tcpa-questionary-custom .d-md-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 992px) {
  .tcpa-questionary-custom .d-lg-none {
    display: none !important; }
  .tcpa-questionary-custom .d-lg-inline {
    display: inline !important; }
  .tcpa-questionary-custom .d-lg-inline-block {
    display: inline-block !important; }
  .tcpa-questionary-custom .d-lg-block {
    display: block !important; }
  .tcpa-questionary-custom .d-lg-table {
    display: table !important; }
  .tcpa-questionary-custom .d-lg-table-row {
    display: table-row !important; }
  .tcpa-questionary-custom .d-lg-table-cell {
    display: table-cell !important; }
  .tcpa-questionary-custom .d-lg-flex {
    display: flex !important; }
  .tcpa-questionary-custom .d-lg-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 1200px) {
  .tcpa-questionary-custom .d-xl-none {
    display: none !important; }
  .tcpa-questionary-custom .d-xl-inline {
    display: inline !important; }
  .tcpa-questionary-custom .d-xl-inline-block {
    display: inline-block !important; }
  .tcpa-questionary-custom .d-xl-block {
    display: block !important; }
  .tcpa-questionary-custom .d-xl-table {
    display: table !important; }
  .tcpa-questionary-custom .d-xl-table-row {
    display: table-row !important; }
  .tcpa-questionary-custom .d-xl-table-cell {
    display: table-cell !important; }
  .tcpa-questionary-custom .d-xl-flex {
    display: flex !important; }
  .tcpa-questionary-custom .d-xl-inline-flex {
    display: inline-flex !important; } }

@media print {
  .tcpa-questionary-custom .d-print-none {
    display: none !important; }
  .tcpa-questionary-custom .d-print-inline {
    display: inline !important; }
  .tcpa-questionary-custom .d-print-inline-block {
    display: inline-block !important; }
  .tcpa-questionary-custom .d-print-block {
    display: block !important; }
  .tcpa-questionary-custom .d-print-table {
    display: table !important; }
  .tcpa-questionary-custom .d-print-table-row {
    display: table-row !important; }
  .tcpa-questionary-custom .d-print-table-cell {
    display: table-cell !important; }
  .tcpa-questionary-custom .d-print-flex {
    display: flex !important; }
  .tcpa-questionary-custom .d-print-inline-flex {
    display: inline-flex !important; } }

.tcpa-questionary-custom .flex-row {
  flex-direction: row !important; }

.tcpa-questionary-custom .flex-column, .tcpa-questionary-custom .tcpa-vertical {
  flex-direction: column !important; }

.tcpa-questionary-custom .flex-row-reverse {
  flex-direction: row-reverse !important; }

.tcpa-questionary-custom .flex-column-reverse {
  flex-direction: column-reverse !important; }

.tcpa-questionary-custom .flex-wrap {
  flex-wrap: wrap !important; }

.tcpa-questionary-custom .flex-nowrap {
  flex-wrap: nowrap !important; }

.tcpa-questionary-custom .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.tcpa-questionary-custom .flex-fill {
  flex: 1 1 auto !important; }

.tcpa-questionary-custom .flex-grow-0 {
  flex-grow: 0 !important; }

.tcpa-questionary-custom .flex-grow-1 {
  flex-grow: 1 !important; }

.tcpa-questionary-custom .flex-shrink-0 {
  flex-shrink: 0 !important; }

.tcpa-questionary-custom .flex-shrink-1 {
  flex-shrink: 1 !important; }

.tcpa-questionary-custom .justify-content-start {
  justify-content: flex-start !important; }

.tcpa-questionary-custom .justify-content-end {
  justify-content: flex-end !important; }

.tcpa-questionary-custom .justify-content-center, .tcpa-questionary-custom .tcpa-item-button, .tcpa-questionary-custom .tcpa-dropdown-container, .tcpa-questionary-custom .tcpa-answers, .tcpa-questionary-custom.tcpa-required.error .tcpa-required-feedback {
  justify-content: center !important; }

.tcpa-questionary-custom .justify-content-between {
  justify-content: space-between !important; }

.tcpa-questionary-custom .justify-content-around {
  justify-content: space-around !important; }

.tcpa-questionary-custom .align-items-start {
  align-items: flex-start !important; }

.tcpa-questionary-custom .align-items-end {
  align-items: flex-end !important; }

.tcpa-questionary-custom .align-items-center, .tcpa-questionary-custom .tcpa-item-button, .tcpa-questionary-custom .tcpa-dropdown-container, .tcpa-questionary-custom .tcpa-answers, .tcpa-questionary-custom.tcpa-required.error .tcpa-required-feedback {
  align-items: center !important; }

.tcpa-questionary-custom .align-items-baseline {
  align-items: baseline !important; }

.tcpa-questionary-custom .align-items-stretch {
  align-items: stretch !important; }

.tcpa-questionary-custom .align-content-start {
  align-content: flex-start !important; }

.tcpa-questionary-custom .align-content-end {
  align-content: flex-end !important; }

.tcpa-questionary-custom .align-content-center {
  align-content: center !important; }

.tcpa-questionary-custom .align-content-between {
  align-content: space-between !important; }

.tcpa-questionary-custom .align-content-around {
  align-content: space-around !important; }

.tcpa-questionary-custom .align-content-stretch {
  align-content: stretch !important; }

.tcpa-questionary-custom .align-self-auto {
  align-self: auto !important; }

.tcpa-questionary-custom .align-self-start {
  align-self: flex-start !important; }

.tcpa-questionary-custom .align-self-end {
  align-self: flex-end !important; }

.tcpa-questionary-custom .align-self-center {
  align-self: center !important; }

.tcpa-questionary-custom .align-self-baseline {
  align-self: baseline !important; }

.tcpa-questionary-custom .align-self-stretch {
  align-self: stretch !important; }

@media (min-width: 576px) {
  .tcpa-questionary-custom .flex-sm-row {
    flex-direction: row !important; }
  .tcpa-questionary-custom .flex-sm-column {
    flex-direction: column !important; }
  .tcpa-questionary-custom .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .tcpa-questionary-custom .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .tcpa-questionary-custom .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .tcpa-questionary-custom .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .tcpa-questionary-custom .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .tcpa-questionary-custom .flex-sm-fill {
    flex: 1 1 auto !important; }
  .tcpa-questionary-custom .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .tcpa-questionary-custom .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .tcpa-questionary-custom .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .tcpa-questionary-custom .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .tcpa-questionary-custom .justify-content-sm-start {
    justify-content: flex-start !important; }
  .tcpa-questionary-custom .justify-content-sm-end {
    justify-content: flex-end !important; }
  .tcpa-questionary-custom .justify-content-sm-center {
    justify-content: center !important; }
  .tcpa-questionary-custom .justify-content-sm-between {
    justify-content: space-between !important; }
  .tcpa-questionary-custom .justify-content-sm-around {
    justify-content: space-around !important; }
  .tcpa-questionary-custom .align-items-sm-start {
    align-items: flex-start !important; }
  .tcpa-questionary-custom .align-items-sm-end {
    align-items: flex-end !important; }
  .tcpa-questionary-custom .align-items-sm-center {
    align-items: center !important; }
  .tcpa-questionary-custom .align-items-sm-baseline {
    align-items: baseline !important; }
  .tcpa-questionary-custom .align-items-sm-stretch {
    align-items: stretch !important; }
  .tcpa-questionary-custom .align-content-sm-start {
    align-content: flex-start !important; }
  .tcpa-questionary-custom .align-content-sm-end {
    align-content: flex-end !important; }
  .tcpa-questionary-custom .align-content-sm-center {
    align-content: center !important; }
  .tcpa-questionary-custom .align-content-sm-between {
    align-content: space-between !important; }
  .tcpa-questionary-custom .align-content-sm-around {
    align-content: space-around !important; }
  .tcpa-questionary-custom .align-content-sm-stretch {
    align-content: stretch !important; }
  .tcpa-questionary-custom .align-self-sm-auto {
    align-self: auto !important; }
  .tcpa-questionary-custom .align-self-sm-start {
    align-self: flex-start !important; }
  .tcpa-questionary-custom .align-self-sm-end {
    align-self: flex-end !important; }
  .tcpa-questionary-custom .align-self-sm-center {
    align-self: center !important; }
  .tcpa-questionary-custom .align-self-sm-baseline {
    align-self: baseline !important; }
  .tcpa-questionary-custom .align-self-sm-stretch {
    align-self: stretch !important; } }

@media (min-width: 768px) {
  .tcpa-questionary-custom .flex-md-row {
    flex-direction: row !important; }
  .tcpa-questionary-custom .flex-md-column {
    flex-direction: column !important; }
  .tcpa-questionary-custom .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .tcpa-questionary-custom .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .tcpa-questionary-custom .flex-md-wrap {
    flex-wrap: wrap !important; }
  .tcpa-questionary-custom .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .tcpa-questionary-custom .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .tcpa-questionary-custom .flex-md-fill {
    flex: 1 1 auto !important; }
  .tcpa-questionary-custom .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .tcpa-questionary-custom .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .tcpa-questionary-custom .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .tcpa-questionary-custom .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .tcpa-questionary-custom .justify-content-md-start {
    justify-content: flex-start !important; }
  .tcpa-questionary-custom .justify-content-md-end {
    justify-content: flex-end !important; }
  .tcpa-questionary-custom .justify-content-md-center {
    justify-content: center !important; }
  .tcpa-questionary-custom .justify-content-md-between {
    justify-content: space-between !important; }
  .tcpa-questionary-custom .justify-content-md-around {
    justify-content: space-around !important; }
  .tcpa-questionary-custom .align-items-md-start {
    align-items: flex-start !important; }
  .tcpa-questionary-custom .align-items-md-end {
    align-items: flex-end !important; }
  .tcpa-questionary-custom .align-items-md-center {
    align-items: center !important; }
  .tcpa-questionary-custom .align-items-md-baseline {
    align-items: baseline !important; }
  .tcpa-questionary-custom .align-items-md-stretch {
    align-items: stretch !important; }
  .tcpa-questionary-custom .align-content-md-start {
    align-content: flex-start !important; }
  .tcpa-questionary-custom .align-content-md-end {
    align-content: flex-end !important; }
  .tcpa-questionary-custom .align-content-md-center {
    align-content: center !important; }
  .tcpa-questionary-custom .align-content-md-between {
    align-content: space-between !important; }
  .tcpa-questionary-custom .align-content-md-around {
    align-content: space-around !important; }
  .tcpa-questionary-custom .align-content-md-stretch {
    align-content: stretch !important; }
  .tcpa-questionary-custom .align-self-md-auto {
    align-self: auto !important; }
  .tcpa-questionary-custom .align-self-md-start {
    align-self: flex-start !important; }
  .tcpa-questionary-custom .align-self-md-end {
    align-self: flex-end !important; }
  .tcpa-questionary-custom .align-self-md-center {
    align-self: center !important; }
  .tcpa-questionary-custom .align-self-md-baseline {
    align-self: baseline !important; }
  .tcpa-questionary-custom .align-self-md-stretch {
    align-self: stretch !important; } }

@media (min-width: 992px) {
  .tcpa-questionary-custom .flex-lg-row {
    flex-direction: row !important; }
  .tcpa-questionary-custom .flex-lg-column {
    flex-direction: column !important; }
  .tcpa-questionary-custom .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .tcpa-questionary-custom .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .tcpa-questionary-custom .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .tcpa-questionary-custom .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .tcpa-questionary-custom .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .tcpa-questionary-custom .flex-lg-fill {
    flex: 1 1 auto !important; }
  .tcpa-questionary-custom .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .tcpa-questionary-custom .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .tcpa-questionary-custom .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .tcpa-questionary-custom .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .tcpa-questionary-custom .justify-content-lg-start {
    justify-content: flex-start !important; }
  .tcpa-questionary-custom .justify-content-lg-end {
    justify-content: flex-end !important; }
  .tcpa-questionary-custom .justify-content-lg-center {
    justify-content: center !important; }
  .tcpa-questionary-custom .justify-content-lg-between {
    justify-content: space-between !important; }
  .tcpa-questionary-custom .justify-content-lg-around {
    justify-content: space-around !important; }
  .tcpa-questionary-custom .align-items-lg-start {
    align-items: flex-start !important; }
  .tcpa-questionary-custom .align-items-lg-end {
    align-items: flex-end !important; }
  .tcpa-questionary-custom .align-items-lg-center {
    align-items: center !important; }
  .tcpa-questionary-custom .align-items-lg-baseline {
    align-items: baseline !important; }
  .tcpa-questionary-custom .align-items-lg-stretch {
    align-items: stretch !important; }
  .tcpa-questionary-custom .align-content-lg-start {
    align-content: flex-start !important; }
  .tcpa-questionary-custom .align-content-lg-end {
    align-content: flex-end !important; }
  .tcpa-questionary-custom .align-content-lg-center {
    align-content: center !important; }
  .tcpa-questionary-custom .align-content-lg-between {
    align-content: space-between !important; }
  .tcpa-questionary-custom .align-content-lg-around {
    align-content: space-around !important; }
  .tcpa-questionary-custom .align-content-lg-stretch {
    align-content: stretch !important; }
  .tcpa-questionary-custom .align-self-lg-auto {
    align-self: auto !important; }
  .tcpa-questionary-custom .align-self-lg-start {
    align-self: flex-start !important; }
  .tcpa-questionary-custom .align-self-lg-end {
    align-self: flex-end !important; }
  .tcpa-questionary-custom .align-self-lg-center {
    align-self: center !important; }
  .tcpa-questionary-custom .align-self-lg-baseline {
    align-self: baseline !important; }
  .tcpa-questionary-custom .align-self-lg-stretch {
    align-self: stretch !important; } }

@media (min-width: 1200px) {
  .tcpa-questionary-custom .flex-xl-row {
    flex-direction: row !important; }
  .tcpa-questionary-custom .flex-xl-column {
    flex-direction: column !important; }
  .tcpa-questionary-custom .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .tcpa-questionary-custom .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .tcpa-questionary-custom .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .tcpa-questionary-custom .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .tcpa-questionary-custom .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .tcpa-questionary-custom .flex-xl-fill {
    flex: 1 1 auto !important; }
  .tcpa-questionary-custom .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .tcpa-questionary-custom .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .tcpa-questionary-custom .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .tcpa-questionary-custom .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .tcpa-questionary-custom .justify-content-xl-start {
    justify-content: flex-start !important; }
  .tcpa-questionary-custom .justify-content-xl-end {
    justify-content: flex-end !important; }
  .tcpa-questionary-custom .justify-content-xl-center {
    justify-content: center !important; }
  .tcpa-questionary-custom .justify-content-xl-between {
    justify-content: space-between !important; }
  .tcpa-questionary-custom .justify-content-xl-around {
    justify-content: space-around !important; }
  .tcpa-questionary-custom .align-items-xl-start {
    align-items: flex-start !important; }
  .tcpa-questionary-custom .align-items-xl-end {
    align-items: flex-end !important; }
  .tcpa-questionary-custom .align-items-xl-center {
    align-items: center !important; }
  .tcpa-questionary-custom .align-items-xl-baseline {
    align-items: baseline !important; }
  .tcpa-questionary-custom .align-items-xl-stretch {
    align-items: stretch !important; }
  .tcpa-questionary-custom .align-content-xl-start {
    align-content: flex-start !important; }
  .tcpa-questionary-custom .align-content-xl-end {
    align-content: flex-end !important; }
  .tcpa-questionary-custom .align-content-xl-center {
    align-content: center !important; }
  .tcpa-questionary-custom .align-content-xl-between {
    align-content: space-between !important; }
  .tcpa-questionary-custom .align-content-xl-around {
    align-content: space-around !important; }
  .tcpa-questionary-custom .align-content-xl-stretch {
    align-content: stretch !important; }
  .tcpa-questionary-custom .align-self-xl-auto {
    align-self: auto !important; }
  .tcpa-questionary-custom .align-self-xl-start {
    align-self: flex-start !important; }
  .tcpa-questionary-custom .align-self-xl-end {
    align-self: flex-end !important; }
  .tcpa-questionary-custom .align-self-xl-center {
    align-self: center !important; }
  .tcpa-questionary-custom .align-self-xl-baseline {
    align-self: baseline !important; }
  .tcpa-questionary-custom .align-self-xl-stretch {
    align-self: stretch !important; } }

.tcpa-questionary-custom .border {
  border: 1px solid #dee2e6 !important; }

.tcpa-questionary-custom .border-top {
  border-top: 1px solid #dee2e6 !important; }

.tcpa-questionary-custom .border-right {
  border-right: 1px solid #dee2e6 !important; }

.tcpa-questionary-custom .border-bottom {
  border-bottom: 1px solid #dee2e6 !important; }

.tcpa-questionary-custom .border-left {
  border-left: 1px solid #dee2e6 !important; }

.tcpa-questionary-custom .border-0, .tcpa-questionary-custom .tcpa-item-button {
  border: 0 !important; }

.tcpa-questionary-custom .border-top-0 {
  border-top: 0 !important; }

.tcpa-questionary-custom .border-right-0 {
  border-right: 0 !important; }

.tcpa-questionary-custom .border-bottom-0 {
  border-bottom: 0 !important; }

.tcpa-questionary-custom .border-left-0 {
  border-left: 0 !important; }

.tcpa-questionary-custom .border-primary {
  border-color: #007bff !important; }

.tcpa-questionary-custom .border-secondary {
  border-color: #6c757d !important; }

.tcpa-questionary-custom .border-success {
  border-color: #28a745 !important; }

.tcpa-questionary-custom .border-info {
  border-color: #17a2b8 !important; }

.tcpa-questionary-custom .border-warning {
  border-color: #ffc107 !important; }

.tcpa-questionary-custom .border-danger {
  border-color: #dc3545 !important; }

.tcpa-questionary-custom .border-light {
  border-color: #f8f9fa !important; }

.tcpa-questionary-custom .border-dark {
  border-color: #343a40 !important; }

.tcpa-questionary-custom .border-white {
  border-color: #fff !important; }

.tcpa-questionary-custom .rounded-sm {
  border-radius: 0.2rem !important; }

.tcpa-questionary-custom .rounded {
  border-radius: 0.25rem !important; }

.tcpa-questionary-custom .rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important; }

.tcpa-questionary-custom .rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important; }

.tcpa-questionary-custom .rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.tcpa-questionary-custom .rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.tcpa-questionary-custom .rounded-lg {
  border-radius: 0.3rem !important; }

.tcpa-questionary-custom .rounded-circle {
  border-radius: 50% !important; }

.tcpa-questionary-custom .rounded-pill {
  border-radius: 50rem !important; }

.tcpa-questionary-custom .rounded-0 {
  border-radius: 0 !important; }

.tcpa-questionary-custom .m-0 {
  margin: 0 !important; }

.tcpa-questionary-custom .mt-0,
.tcpa-questionary-custom .my-0 {
  margin-top: 0 !important; }

.tcpa-questionary-custom .mr-0,
.tcpa-questionary-custom .mx-0 {
  margin-right: 0 !important; }

.tcpa-questionary-custom .mb-0,
.tcpa-questionary-custom .my-0 {
  margin-bottom: 0 !important; }

.tcpa-questionary-custom .ml-0,
.tcpa-questionary-custom .mx-0 {
  margin-left: 0 !important; }

.tcpa-questionary-custom .m-1 {
  margin: 0.25rem !important; }

.tcpa-questionary-custom .mt-1,
.tcpa-questionary-custom .my-1 {
  margin-top: 0.25rem !important; }

.tcpa-questionary-custom .mr-1,
.tcpa-questionary-custom .mx-1 {
  margin-right: 0.25rem !important; }

.tcpa-questionary-custom .mb-1,
.tcpa-questionary-custom .my-1 {
  margin-bottom: 0.25rem !important; }

.tcpa-questionary-custom .ml-1,
.tcpa-questionary-custom .mx-1 {
  margin-left: 0.25rem !important; }

.tcpa-questionary-custom .m-2 {
  margin: 0.5rem !important; }

.tcpa-questionary-custom .mt-2,
.tcpa-questionary-custom .my-2,
.tcpa-questionary-custom .tcpa-item-button {
  margin-top: 0.5rem !important; }

.tcpa-questionary-custom .mr-2,
.tcpa-questionary-custom .mx-2 {
  margin-right: 0.5rem !important; }

.tcpa-questionary-custom .mb-2,
.tcpa-questionary-custom .my-2,
.tcpa-questionary-custom .tcpa-item-button {
  margin-bottom: 0.5rem !important; }

.tcpa-questionary-custom .ml-2,
.tcpa-questionary-custom .mx-2 {
  margin-left: 0.5rem !important; }

.tcpa-questionary-custom .m-3 {
  margin: 1rem !important; }

.tcpa-questionary-custom .mt-3,
.tcpa-questionary-custom .my-3 {
  margin-top: 1rem !important; }

.tcpa-questionary-custom .mr-3,
.tcpa-questionary-custom .mx-3 {
  margin-right: 1rem !important; }

.tcpa-questionary-custom .mb-3,
.tcpa-questionary-custom .my-3 {
  margin-bottom: 1rem !important; }

.tcpa-questionary-custom .ml-3,
.tcpa-questionary-custom .mx-3 {
  margin-left: 1rem !important; }

.tcpa-questionary-custom .m-4 {
  margin: 1.5rem !important; }

.tcpa-questionary-custom .mt-4,
.tcpa-questionary-custom .my-4 {
  margin-top: 1.5rem !important; }

.tcpa-questionary-custom .mr-4,
.tcpa-questionary-custom .mx-4 {
  margin-right: 1.5rem !important; }

.tcpa-questionary-custom .mb-4,
.tcpa-questionary-custom .my-4 {
  margin-bottom: 1.5rem !important; }

.tcpa-questionary-custom .ml-4,
.tcpa-questionary-custom .mx-4 {
  margin-left: 1.5rem !important; }

.tcpa-questionary-custom .m-5 {
  margin: 3rem !important; }

.tcpa-questionary-custom .mt-5,
.tcpa-questionary-custom .my-5 {
  margin-top: 3rem !important; }

.tcpa-questionary-custom .mr-5,
.tcpa-questionary-custom .mx-5 {
  margin-right: 3rem !important; }

.tcpa-questionary-custom .mb-5,
.tcpa-questionary-custom .my-5 {
  margin-bottom: 3rem !important; }

.tcpa-questionary-custom .ml-5,
.tcpa-questionary-custom .mx-5 {
  margin-left: 3rem !important; }

.tcpa-questionary-custom .p-0 {
  padding: 0 !important; }

.tcpa-questionary-custom .pt-0,
.tcpa-questionary-custom .py-0 {
  padding-top: 0 !important; }

.tcpa-questionary-custom .pr-0,
.tcpa-questionary-custom .px-0 {
  padding-right: 0 !important; }

.tcpa-questionary-custom .pb-0,
.tcpa-questionary-custom .py-0 {
  padding-bottom: 0 !important; }

.tcpa-questionary-custom .pl-0,
.tcpa-questionary-custom .px-0 {
  padding-left: 0 !important; }

.tcpa-questionary-custom .p-1 {
  padding: 0.25rem !important; }

.tcpa-questionary-custom .pt-1,
.tcpa-questionary-custom .py-1 {
  padding-top: 0.25rem !important; }

.tcpa-questionary-custom .pr-1,
.tcpa-questionary-custom .px-1 {
  padding-right: 0.25rem !important; }

.tcpa-questionary-custom .pb-1,
.tcpa-questionary-custom .py-1 {
  padding-bottom: 0.25rem !important; }

.tcpa-questionary-custom .pl-1,
.tcpa-questionary-custom .px-1 {
  padding-left: 0.25rem !important; }

.tcpa-questionary-custom .p-2 {
  padding: 0.5rem !important; }

.tcpa-questionary-custom .pt-2,
.tcpa-questionary-custom .py-2 {
  padding-top: 0.5rem !important; }

.tcpa-questionary-custom .pr-2,
.tcpa-questionary-custom .px-2 {
  padding-right: 0.5rem !important; }

.tcpa-questionary-custom .pb-2,
.tcpa-questionary-custom .py-2 {
  padding-bottom: 0.5rem !important; }

.tcpa-questionary-custom .pl-2,
.tcpa-questionary-custom .px-2 {
  padding-left: 0.5rem !important; }

.tcpa-questionary-custom .p-3 {
  padding: 1rem !important; }

.tcpa-questionary-custom .pt-3,
.tcpa-questionary-custom .py-3 {
  padding-top: 1rem !important; }

.tcpa-questionary-custom .pr-3,
.tcpa-questionary-custom .px-3 {
  padding-right: 1rem !important; }

.tcpa-questionary-custom .pb-3,
.tcpa-questionary-custom .py-3 {
  padding-bottom: 1rem !important; }

.tcpa-questionary-custom .pl-3,
.tcpa-questionary-custom .px-3 {
  padding-left: 1rem !important; }

.tcpa-questionary-custom .p-4 {
  padding: 1.5rem !important; }

.tcpa-questionary-custom .pt-4,
.tcpa-questionary-custom .py-4 {
  padding-top: 1.5rem !important; }

.tcpa-questionary-custom .pr-4,
.tcpa-questionary-custom .px-4 {
  padding-right: 1.5rem !important; }

.tcpa-questionary-custom .pb-4,
.tcpa-questionary-custom .py-4 {
  padding-bottom: 1.5rem !important; }

.tcpa-questionary-custom .pl-4,
.tcpa-questionary-custom .px-4 {
  padding-left: 1.5rem !important; }

.tcpa-questionary-custom .p-5 {
  padding: 3rem !important; }

.tcpa-questionary-custom .pt-5,
.tcpa-questionary-custom .py-5 {
  padding-top: 3rem !important; }

.tcpa-questionary-custom .pr-5,
.tcpa-questionary-custom .px-5 {
  padding-right: 3rem !important; }

.tcpa-questionary-custom .pb-5,
.tcpa-questionary-custom .py-5 {
  padding-bottom: 3rem !important; }

.tcpa-questionary-custom .pl-5,
.tcpa-questionary-custom .px-5 {
  padding-left: 3rem !important; }

.tcpa-questionary-custom .m-n1 {
  margin: -0.25rem !important; }

.tcpa-questionary-custom .mt-n1,
.tcpa-questionary-custom .my-n1 {
  margin-top: -0.25rem !important; }

.tcpa-questionary-custom .mr-n1,
.tcpa-questionary-custom .mx-n1 {
  margin-right: -0.25rem !important; }

.tcpa-questionary-custom .mb-n1,
.tcpa-questionary-custom .my-n1 {
  margin-bottom: -0.25rem !important; }

.tcpa-questionary-custom .ml-n1,
.tcpa-questionary-custom .mx-n1 {
  margin-left: -0.25rem !important; }

.tcpa-questionary-custom .m-n2 {
  margin: -0.5rem !important; }

.tcpa-questionary-custom .mt-n2,
.tcpa-questionary-custom .my-n2 {
  margin-top: -0.5rem !important; }

.tcpa-questionary-custom .mr-n2,
.tcpa-questionary-custom .mx-n2 {
  margin-right: -0.5rem !important; }

.tcpa-questionary-custom .mb-n2,
.tcpa-questionary-custom .my-n2 {
  margin-bottom: -0.5rem !important; }

.tcpa-questionary-custom .ml-n2,
.tcpa-questionary-custom .mx-n2 {
  margin-left: -0.5rem !important; }

.tcpa-questionary-custom .m-n3 {
  margin: -1rem !important; }

.tcpa-questionary-custom .mt-n3,
.tcpa-questionary-custom .my-n3 {
  margin-top: -1rem !important; }

.tcpa-questionary-custom .mr-n3,
.tcpa-questionary-custom .mx-n3 {
  margin-right: -1rem !important; }

.tcpa-questionary-custom .mb-n3,
.tcpa-questionary-custom .my-n3 {
  margin-bottom: -1rem !important; }

.tcpa-questionary-custom .ml-n3,
.tcpa-questionary-custom .mx-n3 {
  margin-left: -1rem !important; }

.tcpa-questionary-custom .m-n4 {
  margin: -1.5rem !important; }

.tcpa-questionary-custom .mt-n4,
.tcpa-questionary-custom .my-n4 {
  margin-top: -1.5rem !important; }

.tcpa-questionary-custom .mr-n4,
.tcpa-questionary-custom .mx-n4 {
  margin-right: -1.5rem !important; }

.tcpa-questionary-custom .mb-n4,
.tcpa-questionary-custom .my-n4 {
  margin-bottom: -1.5rem !important; }

.tcpa-questionary-custom .ml-n4,
.tcpa-questionary-custom .mx-n4 {
  margin-left: -1.5rem !important; }

.tcpa-questionary-custom .m-n5 {
  margin: -3rem !important; }

.tcpa-questionary-custom .mt-n5,
.tcpa-questionary-custom .my-n5 {
  margin-top: -3rem !important; }

.tcpa-questionary-custom .mr-n5,
.tcpa-questionary-custom .mx-n5 {
  margin-right: -3rem !important; }

.tcpa-questionary-custom .mb-n5,
.tcpa-questionary-custom .my-n5 {
  margin-bottom: -3rem !important; }

.tcpa-questionary-custom .ml-n5,
.tcpa-questionary-custom .mx-n5 {
  margin-left: -3rem !important; }

.tcpa-questionary-custom .m-auto {
  margin: auto !important; }

.tcpa-questionary-custom .mt-auto,
.tcpa-questionary-custom .my-auto {
  margin-top: auto !important; }

.tcpa-questionary-custom .mr-auto,
.tcpa-questionary-custom .mx-auto {
  margin-right: auto !important; }

.tcpa-questionary-custom .mb-auto,
.tcpa-questionary-custom .my-auto {
  margin-bottom: auto !important; }

.tcpa-questionary-custom .ml-auto,
.tcpa-questionary-custom .mx-auto {
  margin-left: auto !important; }

@media (min-width: 576px) {
  .tcpa-questionary-custom .m-sm-0 {
    margin: 0 !important; }
  .tcpa-questionary-custom .mt-sm-0,
  .tcpa-questionary-custom .my-sm-0 {
    margin-top: 0 !important; }
  .tcpa-questionary-custom .mr-sm-0,
  .tcpa-questionary-custom .mx-sm-0 {
    margin-right: 0 !important; }
  .tcpa-questionary-custom .mb-sm-0,
  .tcpa-questionary-custom .my-sm-0 {
    margin-bottom: 0 !important; }
  .tcpa-questionary-custom .ml-sm-0,
  .tcpa-questionary-custom .mx-sm-0 {
    margin-left: 0 !important; }
  .tcpa-questionary-custom .m-sm-1 {
    margin: 0.25rem !important; }
  .tcpa-questionary-custom .mt-sm-1,
  .tcpa-questionary-custom .my-sm-1 {
    margin-top: 0.25rem !important; }
  .tcpa-questionary-custom .mr-sm-1,
  .tcpa-questionary-custom .mx-sm-1 {
    margin-right: 0.25rem !important; }
  .tcpa-questionary-custom .mb-sm-1,
  .tcpa-questionary-custom .my-sm-1 {
    margin-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .ml-sm-1,
  .tcpa-questionary-custom .mx-sm-1 {
    margin-left: 0.25rem !important; }
  .tcpa-questionary-custom .m-sm-2 {
    margin: 0.5rem !important; }
  .tcpa-questionary-custom .mt-sm-2,
  .tcpa-questionary-custom .my-sm-2 {
    margin-top: 0.5rem !important; }
  .tcpa-questionary-custom .mr-sm-2,
  .tcpa-questionary-custom .mx-sm-2 {
    margin-right: 0.5rem !important; }
  .tcpa-questionary-custom .mb-sm-2,
  .tcpa-questionary-custom .my-sm-2 {
    margin-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .ml-sm-2,
  .tcpa-questionary-custom .mx-sm-2 {
    margin-left: 0.5rem !important; }
  .tcpa-questionary-custom .m-sm-3 {
    margin: 1rem !important; }
  .tcpa-questionary-custom .mt-sm-3,
  .tcpa-questionary-custom .my-sm-3 {
    margin-top: 1rem !important; }
  .tcpa-questionary-custom .mr-sm-3,
  .tcpa-questionary-custom .mx-sm-3 {
    margin-right: 1rem !important; }
  .tcpa-questionary-custom .mb-sm-3,
  .tcpa-questionary-custom .my-sm-3 {
    margin-bottom: 1rem !important; }
  .tcpa-questionary-custom .ml-sm-3,
  .tcpa-questionary-custom .mx-sm-3 {
    margin-left: 1rem !important; }
  .tcpa-questionary-custom .m-sm-4 {
    margin: 1.5rem !important; }
  .tcpa-questionary-custom .mt-sm-4,
  .tcpa-questionary-custom .my-sm-4 {
    margin-top: 1.5rem !important; }
  .tcpa-questionary-custom .mr-sm-4,
  .tcpa-questionary-custom .mx-sm-4 {
    margin-right: 1.5rem !important; }
  .tcpa-questionary-custom .mb-sm-4,
  .tcpa-questionary-custom .my-sm-4 {
    margin-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .ml-sm-4,
  .tcpa-questionary-custom .mx-sm-4 {
    margin-left: 1.5rem !important; }
  .tcpa-questionary-custom .m-sm-5 {
    margin: 3rem !important; }
  .tcpa-questionary-custom .mt-sm-5,
  .tcpa-questionary-custom .my-sm-5 {
    margin-top: 3rem !important; }
  .tcpa-questionary-custom .mr-sm-5,
  .tcpa-questionary-custom .mx-sm-5 {
    margin-right: 3rem !important; }
  .tcpa-questionary-custom .mb-sm-5,
  .tcpa-questionary-custom .my-sm-5 {
    margin-bottom: 3rem !important; }
  .tcpa-questionary-custom .ml-sm-5,
  .tcpa-questionary-custom .mx-sm-5 {
    margin-left: 3rem !important; }
  .tcpa-questionary-custom .p-sm-0 {
    padding: 0 !important; }
  .tcpa-questionary-custom .pt-sm-0,
  .tcpa-questionary-custom .py-sm-0 {
    padding-top: 0 !important; }
  .tcpa-questionary-custom .pr-sm-0,
  .tcpa-questionary-custom .px-sm-0 {
    padding-right: 0 !important; }
  .tcpa-questionary-custom .pb-sm-0,
  .tcpa-questionary-custom .py-sm-0 {
    padding-bottom: 0 !important; }
  .tcpa-questionary-custom .pl-sm-0,
  .tcpa-questionary-custom .px-sm-0 {
    padding-left: 0 !important; }
  .tcpa-questionary-custom .p-sm-1 {
    padding: 0.25rem !important; }
  .tcpa-questionary-custom .pt-sm-1,
  .tcpa-questionary-custom .py-sm-1 {
    padding-top: 0.25rem !important; }
  .tcpa-questionary-custom .pr-sm-1,
  .tcpa-questionary-custom .px-sm-1 {
    padding-right: 0.25rem !important; }
  .tcpa-questionary-custom .pb-sm-1,
  .tcpa-questionary-custom .py-sm-1 {
    padding-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .pl-sm-1,
  .tcpa-questionary-custom .px-sm-1 {
    padding-left: 0.25rem !important; }
  .tcpa-questionary-custom .p-sm-2 {
    padding: 0.5rem !important; }
  .tcpa-questionary-custom .pt-sm-2,
  .tcpa-questionary-custom .py-sm-2 {
    padding-top: 0.5rem !important; }
  .tcpa-questionary-custom .pr-sm-2,
  .tcpa-questionary-custom .px-sm-2 {
    padding-right: 0.5rem !important; }
  .tcpa-questionary-custom .pb-sm-2,
  .tcpa-questionary-custom .py-sm-2 {
    padding-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .pl-sm-2,
  .tcpa-questionary-custom .px-sm-2 {
    padding-left: 0.5rem !important; }
  .tcpa-questionary-custom .p-sm-3 {
    padding: 1rem !important; }
  .tcpa-questionary-custom .pt-sm-3,
  .tcpa-questionary-custom .py-sm-3 {
    padding-top: 1rem !important; }
  .tcpa-questionary-custom .pr-sm-3,
  .tcpa-questionary-custom .px-sm-3 {
    padding-right: 1rem !important; }
  .tcpa-questionary-custom .pb-sm-3,
  .tcpa-questionary-custom .py-sm-3 {
    padding-bottom: 1rem !important; }
  .tcpa-questionary-custom .pl-sm-3,
  .tcpa-questionary-custom .px-sm-3 {
    padding-left: 1rem !important; }
  .tcpa-questionary-custom .p-sm-4 {
    padding: 1.5rem !important; }
  .tcpa-questionary-custom .pt-sm-4,
  .tcpa-questionary-custom .py-sm-4 {
    padding-top: 1.5rem !important; }
  .tcpa-questionary-custom .pr-sm-4,
  .tcpa-questionary-custom .px-sm-4 {
    padding-right: 1.5rem !important; }
  .tcpa-questionary-custom .pb-sm-4,
  .tcpa-questionary-custom .py-sm-4 {
    padding-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .pl-sm-4,
  .tcpa-questionary-custom .px-sm-4 {
    padding-left: 1.5rem !important; }
  .tcpa-questionary-custom .p-sm-5 {
    padding: 3rem !important; }
  .tcpa-questionary-custom .pt-sm-5,
  .tcpa-questionary-custom .py-sm-5 {
    padding-top: 3rem !important; }
  .tcpa-questionary-custom .pr-sm-5,
  .tcpa-questionary-custom .px-sm-5 {
    padding-right: 3rem !important; }
  .tcpa-questionary-custom .pb-sm-5,
  .tcpa-questionary-custom .py-sm-5 {
    padding-bottom: 3rem !important; }
  .tcpa-questionary-custom .pl-sm-5,
  .tcpa-questionary-custom .px-sm-5 {
    padding-left: 3rem !important; }
  .tcpa-questionary-custom .m-sm-n1 {
    margin: -0.25rem !important; }
  .tcpa-questionary-custom .mt-sm-n1,
  .tcpa-questionary-custom .my-sm-n1 {
    margin-top: -0.25rem !important; }
  .tcpa-questionary-custom .mr-sm-n1,
  .tcpa-questionary-custom .mx-sm-n1 {
    margin-right: -0.25rem !important; }
  .tcpa-questionary-custom .mb-sm-n1,
  .tcpa-questionary-custom .my-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .tcpa-questionary-custom .ml-sm-n1,
  .tcpa-questionary-custom .mx-sm-n1 {
    margin-left: -0.25rem !important; }
  .tcpa-questionary-custom .m-sm-n2 {
    margin: -0.5rem !important; }
  .tcpa-questionary-custom .mt-sm-n2,
  .tcpa-questionary-custom .my-sm-n2 {
    margin-top: -0.5rem !important; }
  .tcpa-questionary-custom .mr-sm-n2,
  .tcpa-questionary-custom .mx-sm-n2 {
    margin-right: -0.5rem !important; }
  .tcpa-questionary-custom .mb-sm-n2,
  .tcpa-questionary-custom .my-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .tcpa-questionary-custom .ml-sm-n2,
  .tcpa-questionary-custom .mx-sm-n2 {
    margin-left: -0.5rem !important; }
  .tcpa-questionary-custom .m-sm-n3 {
    margin: -1rem !important; }
  .tcpa-questionary-custom .mt-sm-n3,
  .tcpa-questionary-custom .my-sm-n3 {
    margin-top: -1rem !important; }
  .tcpa-questionary-custom .mr-sm-n3,
  .tcpa-questionary-custom .mx-sm-n3 {
    margin-right: -1rem !important; }
  .tcpa-questionary-custom .mb-sm-n3,
  .tcpa-questionary-custom .my-sm-n3 {
    margin-bottom: -1rem !important; }
  .tcpa-questionary-custom .ml-sm-n3,
  .tcpa-questionary-custom .mx-sm-n3 {
    margin-left: -1rem !important; }
  .tcpa-questionary-custom .m-sm-n4 {
    margin: -1.5rem !important; }
  .tcpa-questionary-custom .mt-sm-n4,
  .tcpa-questionary-custom .my-sm-n4 {
    margin-top: -1.5rem !important; }
  .tcpa-questionary-custom .mr-sm-n4,
  .tcpa-questionary-custom .mx-sm-n4 {
    margin-right: -1.5rem !important; }
  .tcpa-questionary-custom .mb-sm-n4,
  .tcpa-questionary-custom .my-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .tcpa-questionary-custom .ml-sm-n4,
  .tcpa-questionary-custom .mx-sm-n4 {
    margin-left: -1.5rem !important; }
  .tcpa-questionary-custom .m-sm-n5 {
    margin: -3rem !important; }
  .tcpa-questionary-custom .mt-sm-n5,
  .tcpa-questionary-custom .my-sm-n5 {
    margin-top: -3rem !important; }
  .tcpa-questionary-custom .mr-sm-n5,
  .tcpa-questionary-custom .mx-sm-n5 {
    margin-right: -3rem !important; }
  .tcpa-questionary-custom .mb-sm-n5,
  .tcpa-questionary-custom .my-sm-n5 {
    margin-bottom: -3rem !important; }
  .tcpa-questionary-custom .ml-sm-n5,
  .tcpa-questionary-custom .mx-sm-n5 {
    margin-left: -3rem !important; }
  .tcpa-questionary-custom .m-sm-auto {
    margin: auto !important; }
  .tcpa-questionary-custom .mt-sm-auto,
  .tcpa-questionary-custom .my-sm-auto {
    margin-top: auto !important; }
  .tcpa-questionary-custom .mr-sm-auto,
  .tcpa-questionary-custom .mx-sm-auto {
    margin-right: auto !important; }
  .tcpa-questionary-custom .mb-sm-auto,
  .tcpa-questionary-custom .my-sm-auto {
    margin-bottom: auto !important; }
  .tcpa-questionary-custom .ml-sm-auto,
  .tcpa-questionary-custom .mx-sm-auto {
    margin-left: auto !important; } }

@media (min-width: 768px) {
  .tcpa-questionary-custom .m-md-0 {
    margin: 0 !important; }
  .tcpa-questionary-custom .mt-md-0,
  .tcpa-questionary-custom .my-md-0 {
    margin-top: 0 !important; }
  .tcpa-questionary-custom .mr-md-0,
  .tcpa-questionary-custom .mx-md-0 {
    margin-right: 0 !important; }
  .tcpa-questionary-custom .mb-md-0,
  .tcpa-questionary-custom .my-md-0 {
    margin-bottom: 0 !important; }
  .tcpa-questionary-custom .ml-md-0,
  .tcpa-questionary-custom .mx-md-0 {
    margin-left: 0 !important; }
  .tcpa-questionary-custom .m-md-1 {
    margin: 0.25rem !important; }
  .tcpa-questionary-custom .mt-md-1,
  .tcpa-questionary-custom .my-md-1 {
    margin-top: 0.25rem !important; }
  .tcpa-questionary-custom .mr-md-1,
  .tcpa-questionary-custom .mx-md-1 {
    margin-right: 0.25rem !important; }
  .tcpa-questionary-custom .mb-md-1,
  .tcpa-questionary-custom .my-md-1 {
    margin-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .ml-md-1,
  .tcpa-questionary-custom .mx-md-1 {
    margin-left: 0.25rem !important; }
  .tcpa-questionary-custom .m-md-2 {
    margin: 0.5rem !important; }
  .tcpa-questionary-custom .mt-md-2,
  .tcpa-questionary-custom .my-md-2 {
    margin-top: 0.5rem !important; }
  .tcpa-questionary-custom .mr-md-2,
  .tcpa-questionary-custom .mx-md-2 {
    margin-right: 0.5rem !important; }
  .tcpa-questionary-custom .mb-md-2,
  .tcpa-questionary-custom .my-md-2 {
    margin-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .ml-md-2,
  .tcpa-questionary-custom .mx-md-2 {
    margin-left: 0.5rem !important; }
  .tcpa-questionary-custom .m-md-3 {
    margin: 1rem !important; }
  .tcpa-questionary-custom .mt-md-3,
  .tcpa-questionary-custom .my-md-3 {
    margin-top: 1rem !important; }
  .tcpa-questionary-custom .mr-md-3,
  .tcpa-questionary-custom .mx-md-3 {
    margin-right: 1rem !important; }
  .tcpa-questionary-custom .mb-md-3,
  .tcpa-questionary-custom .my-md-3 {
    margin-bottom: 1rem !important; }
  .tcpa-questionary-custom .ml-md-3,
  .tcpa-questionary-custom .mx-md-3 {
    margin-left: 1rem !important; }
  .tcpa-questionary-custom .m-md-4 {
    margin: 1.5rem !important; }
  .tcpa-questionary-custom .mt-md-4,
  .tcpa-questionary-custom .my-md-4 {
    margin-top: 1.5rem !important; }
  .tcpa-questionary-custom .mr-md-4,
  .tcpa-questionary-custom .mx-md-4 {
    margin-right: 1.5rem !important; }
  .tcpa-questionary-custom .mb-md-4,
  .tcpa-questionary-custom .my-md-4 {
    margin-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .ml-md-4,
  .tcpa-questionary-custom .mx-md-4 {
    margin-left: 1.5rem !important; }
  .tcpa-questionary-custom .m-md-5 {
    margin: 3rem !important; }
  .tcpa-questionary-custom .mt-md-5,
  .tcpa-questionary-custom .my-md-5 {
    margin-top: 3rem !important; }
  .tcpa-questionary-custom .mr-md-5,
  .tcpa-questionary-custom .mx-md-5 {
    margin-right: 3rem !important; }
  .tcpa-questionary-custom .mb-md-5,
  .tcpa-questionary-custom .my-md-5 {
    margin-bottom: 3rem !important; }
  .tcpa-questionary-custom .ml-md-5,
  .tcpa-questionary-custom .mx-md-5 {
    margin-left: 3rem !important; }
  .tcpa-questionary-custom .p-md-0 {
    padding: 0 !important; }
  .tcpa-questionary-custom .pt-md-0,
  .tcpa-questionary-custom .py-md-0 {
    padding-top: 0 !important; }
  .tcpa-questionary-custom .pr-md-0,
  .tcpa-questionary-custom .px-md-0 {
    padding-right: 0 !important; }
  .tcpa-questionary-custom .pb-md-0,
  .tcpa-questionary-custom .py-md-0 {
    padding-bottom: 0 !important; }
  .tcpa-questionary-custom .pl-md-0,
  .tcpa-questionary-custom .px-md-0 {
    padding-left: 0 !important; }
  .tcpa-questionary-custom .p-md-1 {
    padding: 0.25rem !important; }
  .tcpa-questionary-custom .pt-md-1,
  .tcpa-questionary-custom .py-md-1 {
    padding-top: 0.25rem !important; }
  .tcpa-questionary-custom .pr-md-1,
  .tcpa-questionary-custom .px-md-1 {
    padding-right: 0.25rem !important; }
  .tcpa-questionary-custom .pb-md-1,
  .tcpa-questionary-custom .py-md-1 {
    padding-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .pl-md-1,
  .tcpa-questionary-custom .px-md-1 {
    padding-left: 0.25rem !important; }
  .tcpa-questionary-custom .p-md-2 {
    padding: 0.5rem !important; }
  .tcpa-questionary-custom .pt-md-2,
  .tcpa-questionary-custom .py-md-2 {
    padding-top: 0.5rem !important; }
  .tcpa-questionary-custom .pr-md-2,
  .tcpa-questionary-custom .px-md-2 {
    padding-right: 0.5rem !important; }
  .tcpa-questionary-custom .pb-md-2,
  .tcpa-questionary-custom .py-md-2 {
    padding-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .pl-md-2,
  .tcpa-questionary-custom .px-md-2 {
    padding-left: 0.5rem !important; }
  .tcpa-questionary-custom .p-md-3 {
    padding: 1rem !important; }
  .tcpa-questionary-custom .pt-md-3,
  .tcpa-questionary-custom .py-md-3 {
    padding-top: 1rem !important; }
  .tcpa-questionary-custom .pr-md-3,
  .tcpa-questionary-custom .px-md-3 {
    padding-right: 1rem !important; }
  .tcpa-questionary-custom .pb-md-3,
  .tcpa-questionary-custom .py-md-3 {
    padding-bottom: 1rem !important; }
  .tcpa-questionary-custom .pl-md-3,
  .tcpa-questionary-custom .px-md-3 {
    padding-left: 1rem !important; }
  .tcpa-questionary-custom .p-md-4 {
    padding: 1.5rem !important; }
  .tcpa-questionary-custom .pt-md-4,
  .tcpa-questionary-custom .py-md-4 {
    padding-top: 1.5rem !important; }
  .tcpa-questionary-custom .pr-md-4,
  .tcpa-questionary-custom .px-md-4 {
    padding-right: 1.5rem !important; }
  .tcpa-questionary-custom .pb-md-4,
  .tcpa-questionary-custom .py-md-4 {
    padding-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .pl-md-4,
  .tcpa-questionary-custom .px-md-4 {
    padding-left: 1.5rem !important; }
  .tcpa-questionary-custom .p-md-5 {
    padding: 3rem !important; }
  .tcpa-questionary-custom .pt-md-5,
  .tcpa-questionary-custom .py-md-5 {
    padding-top: 3rem !important; }
  .tcpa-questionary-custom .pr-md-5,
  .tcpa-questionary-custom .px-md-5 {
    padding-right: 3rem !important; }
  .tcpa-questionary-custom .pb-md-5,
  .tcpa-questionary-custom .py-md-5 {
    padding-bottom: 3rem !important; }
  .tcpa-questionary-custom .pl-md-5,
  .tcpa-questionary-custom .px-md-5 {
    padding-left: 3rem !important; }
  .tcpa-questionary-custom .m-md-n1 {
    margin: -0.25rem !important; }
  .tcpa-questionary-custom .mt-md-n1,
  .tcpa-questionary-custom .my-md-n1 {
    margin-top: -0.25rem !important; }
  .tcpa-questionary-custom .mr-md-n1,
  .tcpa-questionary-custom .mx-md-n1 {
    margin-right: -0.25rem !important; }
  .tcpa-questionary-custom .mb-md-n1,
  .tcpa-questionary-custom .my-md-n1 {
    margin-bottom: -0.25rem !important; }
  .tcpa-questionary-custom .ml-md-n1,
  .tcpa-questionary-custom .mx-md-n1 {
    margin-left: -0.25rem !important; }
  .tcpa-questionary-custom .m-md-n2 {
    margin: -0.5rem !important; }
  .tcpa-questionary-custom .mt-md-n2,
  .tcpa-questionary-custom .my-md-n2 {
    margin-top: -0.5rem !important; }
  .tcpa-questionary-custom .mr-md-n2,
  .tcpa-questionary-custom .mx-md-n2 {
    margin-right: -0.5rem !important; }
  .tcpa-questionary-custom .mb-md-n2,
  .tcpa-questionary-custom .my-md-n2 {
    margin-bottom: -0.5rem !important; }
  .tcpa-questionary-custom .ml-md-n2,
  .tcpa-questionary-custom .mx-md-n2 {
    margin-left: -0.5rem !important; }
  .tcpa-questionary-custom .m-md-n3 {
    margin: -1rem !important; }
  .tcpa-questionary-custom .mt-md-n3,
  .tcpa-questionary-custom .my-md-n3 {
    margin-top: -1rem !important; }
  .tcpa-questionary-custom .mr-md-n3,
  .tcpa-questionary-custom .mx-md-n3 {
    margin-right: -1rem !important; }
  .tcpa-questionary-custom .mb-md-n3,
  .tcpa-questionary-custom .my-md-n3 {
    margin-bottom: -1rem !important; }
  .tcpa-questionary-custom .ml-md-n3,
  .tcpa-questionary-custom .mx-md-n3 {
    margin-left: -1rem !important; }
  .tcpa-questionary-custom .m-md-n4 {
    margin: -1.5rem !important; }
  .tcpa-questionary-custom .mt-md-n4,
  .tcpa-questionary-custom .my-md-n4 {
    margin-top: -1.5rem !important; }
  .tcpa-questionary-custom .mr-md-n4,
  .tcpa-questionary-custom .mx-md-n4 {
    margin-right: -1.5rem !important; }
  .tcpa-questionary-custom .mb-md-n4,
  .tcpa-questionary-custom .my-md-n4 {
    margin-bottom: -1.5rem !important; }
  .tcpa-questionary-custom .ml-md-n4,
  .tcpa-questionary-custom .mx-md-n4 {
    margin-left: -1.5rem !important; }
  .tcpa-questionary-custom .m-md-n5 {
    margin: -3rem !important; }
  .tcpa-questionary-custom .mt-md-n5,
  .tcpa-questionary-custom .my-md-n5 {
    margin-top: -3rem !important; }
  .tcpa-questionary-custom .mr-md-n5,
  .tcpa-questionary-custom .mx-md-n5 {
    margin-right: -3rem !important; }
  .tcpa-questionary-custom .mb-md-n5,
  .tcpa-questionary-custom .my-md-n5 {
    margin-bottom: -3rem !important; }
  .tcpa-questionary-custom .ml-md-n5,
  .tcpa-questionary-custom .mx-md-n5 {
    margin-left: -3rem !important; }
  .tcpa-questionary-custom .m-md-auto {
    margin: auto !important; }
  .tcpa-questionary-custom .mt-md-auto,
  .tcpa-questionary-custom .my-md-auto {
    margin-top: auto !important; }
  .tcpa-questionary-custom .mr-md-auto,
  .tcpa-questionary-custom .mx-md-auto {
    margin-right: auto !important; }
  .tcpa-questionary-custom .mb-md-auto,
  .tcpa-questionary-custom .my-md-auto {
    margin-bottom: auto !important; }
  .tcpa-questionary-custom .ml-md-auto,
  .tcpa-questionary-custom .mx-md-auto {
    margin-left: auto !important; } }

@media (min-width: 992px) {
  .tcpa-questionary-custom .m-lg-0 {
    margin: 0 !important; }
  .tcpa-questionary-custom .mt-lg-0,
  .tcpa-questionary-custom .my-lg-0 {
    margin-top: 0 !important; }
  .tcpa-questionary-custom .mr-lg-0,
  .tcpa-questionary-custom .mx-lg-0 {
    margin-right: 0 !important; }
  .tcpa-questionary-custom .mb-lg-0,
  .tcpa-questionary-custom .my-lg-0 {
    margin-bottom: 0 !important; }
  .tcpa-questionary-custom .ml-lg-0,
  .tcpa-questionary-custom .mx-lg-0 {
    margin-left: 0 !important; }
  .tcpa-questionary-custom .m-lg-1 {
    margin: 0.25rem !important; }
  .tcpa-questionary-custom .mt-lg-1,
  .tcpa-questionary-custom .my-lg-1 {
    margin-top: 0.25rem !important; }
  .tcpa-questionary-custom .mr-lg-1,
  .tcpa-questionary-custom .mx-lg-1 {
    margin-right: 0.25rem !important; }
  .tcpa-questionary-custom .mb-lg-1,
  .tcpa-questionary-custom .my-lg-1 {
    margin-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .ml-lg-1,
  .tcpa-questionary-custom .mx-lg-1 {
    margin-left: 0.25rem !important; }
  .tcpa-questionary-custom .m-lg-2 {
    margin: 0.5rem !important; }
  .tcpa-questionary-custom .mt-lg-2,
  .tcpa-questionary-custom .my-lg-2 {
    margin-top: 0.5rem !important; }
  .tcpa-questionary-custom .mr-lg-2,
  .tcpa-questionary-custom .mx-lg-2 {
    margin-right: 0.5rem !important; }
  .tcpa-questionary-custom .mb-lg-2,
  .tcpa-questionary-custom .my-lg-2 {
    margin-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .ml-lg-2,
  .tcpa-questionary-custom .mx-lg-2 {
    margin-left: 0.5rem !important; }
  .tcpa-questionary-custom .m-lg-3 {
    margin: 1rem !important; }
  .tcpa-questionary-custom .mt-lg-3,
  .tcpa-questionary-custom .my-lg-3 {
    margin-top: 1rem !important; }
  .tcpa-questionary-custom .mr-lg-3,
  .tcpa-questionary-custom .mx-lg-3 {
    margin-right: 1rem !important; }
  .tcpa-questionary-custom .mb-lg-3,
  .tcpa-questionary-custom .my-lg-3 {
    margin-bottom: 1rem !important; }
  .tcpa-questionary-custom .ml-lg-3,
  .tcpa-questionary-custom .mx-lg-3 {
    margin-left: 1rem !important; }
  .tcpa-questionary-custom .m-lg-4 {
    margin: 1.5rem !important; }
  .tcpa-questionary-custom .mt-lg-4,
  .tcpa-questionary-custom .my-lg-4 {
    margin-top: 1.5rem !important; }
  .tcpa-questionary-custom .mr-lg-4,
  .tcpa-questionary-custom .mx-lg-4 {
    margin-right: 1.5rem !important; }
  .tcpa-questionary-custom .mb-lg-4,
  .tcpa-questionary-custom .my-lg-4 {
    margin-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .ml-lg-4,
  .tcpa-questionary-custom .mx-lg-4 {
    margin-left: 1.5rem !important; }
  .tcpa-questionary-custom .m-lg-5 {
    margin: 3rem !important; }
  .tcpa-questionary-custom .mt-lg-5,
  .tcpa-questionary-custom .my-lg-5 {
    margin-top: 3rem !important; }
  .tcpa-questionary-custom .mr-lg-5,
  .tcpa-questionary-custom .mx-lg-5 {
    margin-right: 3rem !important; }
  .tcpa-questionary-custom .mb-lg-5,
  .tcpa-questionary-custom .my-lg-5 {
    margin-bottom: 3rem !important; }
  .tcpa-questionary-custom .ml-lg-5,
  .tcpa-questionary-custom .mx-lg-5 {
    margin-left: 3rem !important; }
  .tcpa-questionary-custom .p-lg-0 {
    padding: 0 !important; }
  .tcpa-questionary-custom .pt-lg-0,
  .tcpa-questionary-custom .py-lg-0 {
    padding-top: 0 !important; }
  .tcpa-questionary-custom .pr-lg-0,
  .tcpa-questionary-custom .px-lg-0 {
    padding-right: 0 !important; }
  .tcpa-questionary-custom .pb-lg-0,
  .tcpa-questionary-custom .py-lg-0 {
    padding-bottom: 0 !important; }
  .tcpa-questionary-custom .pl-lg-0,
  .tcpa-questionary-custom .px-lg-0 {
    padding-left: 0 !important; }
  .tcpa-questionary-custom .p-lg-1 {
    padding: 0.25rem !important; }
  .tcpa-questionary-custom .pt-lg-1,
  .tcpa-questionary-custom .py-lg-1 {
    padding-top: 0.25rem !important; }
  .tcpa-questionary-custom .pr-lg-1,
  .tcpa-questionary-custom .px-lg-1 {
    padding-right: 0.25rem !important; }
  .tcpa-questionary-custom .pb-lg-1,
  .tcpa-questionary-custom .py-lg-1 {
    padding-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .pl-lg-1,
  .tcpa-questionary-custom .px-lg-1 {
    padding-left: 0.25rem !important; }
  .tcpa-questionary-custom .p-lg-2 {
    padding: 0.5rem !important; }
  .tcpa-questionary-custom .pt-lg-2,
  .tcpa-questionary-custom .py-lg-2 {
    padding-top: 0.5rem !important; }
  .tcpa-questionary-custom .pr-lg-2,
  .tcpa-questionary-custom .px-lg-2 {
    padding-right: 0.5rem !important; }
  .tcpa-questionary-custom .pb-lg-2,
  .tcpa-questionary-custom .py-lg-2 {
    padding-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .pl-lg-2,
  .tcpa-questionary-custom .px-lg-2 {
    padding-left: 0.5rem !important; }
  .tcpa-questionary-custom .p-lg-3 {
    padding: 1rem !important; }
  .tcpa-questionary-custom .pt-lg-3,
  .tcpa-questionary-custom .py-lg-3 {
    padding-top: 1rem !important; }
  .tcpa-questionary-custom .pr-lg-3,
  .tcpa-questionary-custom .px-lg-3 {
    padding-right: 1rem !important; }
  .tcpa-questionary-custom .pb-lg-3,
  .tcpa-questionary-custom .py-lg-3 {
    padding-bottom: 1rem !important; }
  .tcpa-questionary-custom .pl-lg-3,
  .tcpa-questionary-custom .px-lg-3 {
    padding-left: 1rem !important; }
  .tcpa-questionary-custom .p-lg-4 {
    padding: 1.5rem !important; }
  .tcpa-questionary-custom .pt-lg-4,
  .tcpa-questionary-custom .py-lg-4 {
    padding-top: 1.5rem !important; }
  .tcpa-questionary-custom .pr-lg-4,
  .tcpa-questionary-custom .px-lg-4 {
    padding-right: 1.5rem !important; }
  .tcpa-questionary-custom .pb-lg-4,
  .tcpa-questionary-custom .py-lg-4 {
    padding-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .pl-lg-4,
  .tcpa-questionary-custom .px-lg-4 {
    padding-left: 1.5rem !important; }
  .tcpa-questionary-custom .p-lg-5 {
    padding: 3rem !important; }
  .tcpa-questionary-custom .pt-lg-5,
  .tcpa-questionary-custom .py-lg-5 {
    padding-top: 3rem !important; }
  .tcpa-questionary-custom .pr-lg-5,
  .tcpa-questionary-custom .px-lg-5 {
    padding-right: 3rem !important; }
  .tcpa-questionary-custom .pb-lg-5,
  .tcpa-questionary-custom .py-lg-5 {
    padding-bottom: 3rem !important; }
  .tcpa-questionary-custom .pl-lg-5,
  .tcpa-questionary-custom .px-lg-5 {
    padding-left: 3rem !important; }
  .tcpa-questionary-custom .m-lg-n1 {
    margin: -0.25rem !important; }
  .tcpa-questionary-custom .mt-lg-n1,
  .tcpa-questionary-custom .my-lg-n1 {
    margin-top: -0.25rem !important; }
  .tcpa-questionary-custom .mr-lg-n1,
  .tcpa-questionary-custom .mx-lg-n1 {
    margin-right: -0.25rem !important; }
  .tcpa-questionary-custom .mb-lg-n1,
  .tcpa-questionary-custom .my-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .tcpa-questionary-custom .ml-lg-n1,
  .tcpa-questionary-custom .mx-lg-n1 {
    margin-left: -0.25rem !important; }
  .tcpa-questionary-custom .m-lg-n2 {
    margin: -0.5rem !important; }
  .tcpa-questionary-custom .mt-lg-n2,
  .tcpa-questionary-custom .my-lg-n2 {
    margin-top: -0.5rem !important; }
  .tcpa-questionary-custom .mr-lg-n2,
  .tcpa-questionary-custom .mx-lg-n2 {
    margin-right: -0.5rem !important; }
  .tcpa-questionary-custom .mb-lg-n2,
  .tcpa-questionary-custom .my-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .tcpa-questionary-custom .ml-lg-n2,
  .tcpa-questionary-custom .mx-lg-n2 {
    margin-left: -0.5rem !important; }
  .tcpa-questionary-custom .m-lg-n3 {
    margin: -1rem !important; }
  .tcpa-questionary-custom .mt-lg-n3,
  .tcpa-questionary-custom .my-lg-n3 {
    margin-top: -1rem !important; }
  .tcpa-questionary-custom .mr-lg-n3,
  .tcpa-questionary-custom .mx-lg-n3 {
    margin-right: -1rem !important; }
  .tcpa-questionary-custom .mb-lg-n3,
  .tcpa-questionary-custom .my-lg-n3 {
    margin-bottom: -1rem !important; }
  .tcpa-questionary-custom .ml-lg-n3,
  .tcpa-questionary-custom .mx-lg-n3 {
    margin-left: -1rem !important; }
  .tcpa-questionary-custom .m-lg-n4 {
    margin: -1.5rem !important; }
  .tcpa-questionary-custom .mt-lg-n4,
  .tcpa-questionary-custom .my-lg-n4 {
    margin-top: -1.5rem !important; }
  .tcpa-questionary-custom .mr-lg-n4,
  .tcpa-questionary-custom .mx-lg-n4 {
    margin-right: -1.5rem !important; }
  .tcpa-questionary-custom .mb-lg-n4,
  .tcpa-questionary-custom .my-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .tcpa-questionary-custom .ml-lg-n4,
  .tcpa-questionary-custom .mx-lg-n4 {
    margin-left: -1.5rem !important; }
  .tcpa-questionary-custom .m-lg-n5 {
    margin: -3rem !important; }
  .tcpa-questionary-custom .mt-lg-n5,
  .tcpa-questionary-custom .my-lg-n5 {
    margin-top: -3rem !important; }
  .tcpa-questionary-custom .mr-lg-n5,
  .tcpa-questionary-custom .mx-lg-n5 {
    margin-right: -3rem !important; }
  .tcpa-questionary-custom .mb-lg-n5,
  .tcpa-questionary-custom .my-lg-n5 {
    margin-bottom: -3rem !important; }
  .tcpa-questionary-custom .ml-lg-n5,
  .tcpa-questionary-custom .mx-lg-n5 {
    margin-left: -3rem !important; }
  .tcpa-questionary-custom .m-lg-auto {
    margin: auto !important; }
  .tcpa-questionary-custom .mt-lg-auto,
  .tcpa-questionary-custom .my-lg-auto {
    margin-top: auto !important; }
  .tcpa-questionary-custom .mr-lg-auto,
  .tcpa-questionary-custom .mx-lg-auto {
    margin-right: auto !important; }
  .tcpa-questionary-custom .mb-lg-auto,
  .tcpa-questionary-custom .my-lg-auto {
    margin-bottom: auto !important; }
  .tcpa-questionary-custom .ml-lg-auto,
  .tcpa-questionary-custom .mx-lg-auto {
    margin-left: auto !important; } }

@media (min-width: 1200px) {
  .tcpa-questionary-custom .m-xl-0 {
    margin: 0 !important; }
  .tcpa-questionary-custom .mt-xl-0,
  .tcpa-questionary-custom .my-xl-0 {
    margin-top: 0 !important; }
  .tcpa-questionary-custom .mr-xl-0,
  .tcpa-questionary-custom .mx-xl-0 {
    margin-right: 0 !important; }
  .tcpa-questionary-custom .mb-xl-0,
  .tcpa-questionary-custom .my-xl-0 {
    margin-bottom: 0 !important; }
  .tcpa-questionary-custom .ml-xl-0,
  .tcpa-questionary-custom .mx-xl-0 {
    margin-left: 0 !important; }
  .tcpa-questionary-custom .m-xl-1 {
    margin: 0.25rem !important; }
  .tcpa-questionary-custom .mt-xl-1,
  .tcpa-questionary-custom .my-xl-1 {
    margin-top: 0.25rem !important; }
  .tcpa-questionary-custom .mr-xl-1,
  .tcpa-questionary-custom .mx-xl-1 {
    margin-right: 0.25rem !important; }
  .tcpa-questionary-custom .mb-xl-1,
  .tcpa-questionary-custom .my-xl-1 {
    margin-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .ml-xl-1,
  .tcpa-questionary-custom .mx-xl-1 {
    margin-left: 0.25rem !important; }
  .tcpa-questionary-custom .m-xl-2 {
    margin: 0.5rem !important; }
  .tcpa-questionary-custom .mt-xl-2,
  .tcpa-questionary-custom .my-xl-2 {
    margin-top: 0.5rem !important; }
  .tcpa-questionary-custom .mr-xl-2,
  .tcpa-questionary-custom .mx-xl-2 {
    margin-right: 0.5rem !important; }
  .tcpa-questionary-custom .mb-xl-2,
  .tcpa-questionary-custom .my-xl-2 {
    margin-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .ml-xl-2,
  .tcpa-questionary-custom .mx-xl-2 {
    margin-left: 0.5rem !important; }
  .tcpa-questionary-custom .m-xl-3 {
    margin: 1rem !important; }
  .tcpa-questionary-custom .mt-xl-3,
  .tcpa-questionary-custom .my-xl-3 {
    margin-top: 1rem !important; }
  .tcpa-questionary-custom .mr-xl-3,
  .tcpa-questionary-custom .mx-xl-3 {
    margin-right: 1rem !important; }
  .tcpa-questionary-custom .mb-xl-3,
  .tcpa-questionary-custom .my-xl-3 {
    margin-bottom: 1rem !important; }
  .tcpa-questionary-custom .ml-xl-3,
  .tcpa-questionary-custom .mx-xl-3 {
    margin-left: 1rem !important; }
  .tcpa-questionary-custom .m-xl-4 {
    margin: 1.5rem !important; }
  .tcpa-questionary-custom .mt-xl-4,
  .tcpa-questionary-custom .my-xl-4 {
    margin-top: 1.5rem !important; }
  .tcpa-questionary-custom .mr-xl-4,
  .tcpa-questionary-custom .mx-xl-4 {
    margin-right: 1.5rem !important; }
  .tcpa-questionary-custom .mb-xl-4,
  .tcpa-questionary-custom .my-xl-4 {
    margin-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .ml-xl-4,
  .tcpa-questionary-custom .mx-xl-4 {
    margin-left: 1.5rem !important; }
  .tcpa-questionary-custom .m-xl-5 {
    margin: 3rem !important; }
  .tcpa-questionary-custom .mt-xl-5,
  .tcpa-questionary-custom .my-xl-5 {
    margin-top: 3rem !important; }
  .tcpa-questionary-custom .mr-xl-5,
  .tcpa-questionary-custom .mx-xl-5 {
    margin-right: 3rem !important; }
  .tcpa-questionary-custom .mb-xl-5,
  .tcpa-questionary-custom .my-xl-5 {
    margin-bottom: 3rem !important; }
  .tcpa-questionary-custom .ml-xl-5,
  .tcpa-questionary-custom .mx-xl-5 {
    margin-left: 3rem !important; }
  .tcpa-questionary-custom .p-xl-0 {
    padding: 0 !important; }
  .tcpa-questionary-custom .pt-xl-0,
  .tcpa-questionary-custom .py-xl-0 {
    padding-top: 0 !important; }
  .tcpa-questionary-custom .pr-xl-0,
  .tcpa-questionary-custom .px-xl-0 {
    padding-right: 0 !important; }
  .tcpa-questionary-custom .pb-xl-0,
  .tcpa-questionary-custom .py-xl-0 {
    padding-bottom: 0 !important; }
  .tcpa-questionary-custom .pl-xl-0,
  .tcpa-questionary-custom .px-xl-0 {
    padding-left: 0 !important; }
  .tcpa-questionary-custom .p-xl-1 {
    padding: 0.25rem !important; }
  .tcpa-questionary-custom .pt-xl-1,
  .tcpa-questionary-custom .py-xl-1 {
    padding-top: 0.25rem !important; }
  .tcpa-questionary-custom .pr-xl-1,
  .tcpa-questionary-custom .px-xl-1 {
    padding-right: 0.25rem !important; }
  .tcpa-questionary-custom .pb-xl-1,
  .tcpa-questionary-custom .py-xl-1 {
    padding-bottom: 0.25rem !important; }
  .tcpa-questionary-custom .pl-xl-1,
  .tcpa-questionary-custom .px-xl-1 {
    padding-left: 0.25rem !important; }
  .tcpa-questionary-custom .p-xl-2 {
    padding: 0.5rem !important; }
  .tcpa-questionary-custom .pt-xl-2,
  .tcpa-questionary-custom .py-xl-2 {
    padding-top: 0.5rem !important; }
  .tcpa-questionary-custom .pr-xl-2,
  .tcpa-questionary-custom .px-xl-2 {
    padding-right: 0.5rem !important; }
  .tcpa-questionary-custom .pb-xl-2,
  .tcpa-questionary-custom .py-xl-2 {
    padding-bottom: 0.5rem !important; }
  .tcpa-questionary-custom .pl-xl-2,
  .tcpa-questionary-custom .px-xl-2 {
    padding-left: 0.5rem !important; }
  .tcpa-questionary-custom .p-xl-3 {
    padding: 1rem !important; }
  .tcpa-questionary-custom .pt-xl-3,
  .tcpa-questionary-custom .py-xl-3 {
    padding-top: 1rem !important; }
  .tcpa-questionary-custom .pr-xl-3,
  .tcpa-questionary-custom .px-xl-3 {
    padding-right: 1rem !important; }
  .tcpa-questionary-custom .pb-xl-3,
  .tcpa-questionary-custom .py-xl-3 {
    padding-bottom: 1rem !important; }
  .tcpa-questionary-custom .pl-xl-3,
  .tcpa-questionary-custom .px-xl-3 {
    padding-left: 1rem !important; }
  .tcpa-questionary-custom .p-xl-4 {
    padding: 1.5rem !important; }
  .tcpa-questionary-custom .pt-xl-4,
  .tcpa-questionary-custom .py-xl-4 {
    padding-top: 1.5rem !important; }
  .tcpa-questionary-custom .pr-xl-4,
  .tcpa-questionary-custom .px-xl-4 {
    padding-right: 1.5rem !important; }
  .tcpa-questionary-custom .pb-xl-4,
  .tcpa-questionary-custom .py-xl-4 {
    padding-bottom: 1.5rem !important; }
  .tcpa-questionary-custom .pl-xl-4,
  .tcpa-questionary-custom .px-xl-4 {
    padding-left: 1.5rem !important; }
  .tcpa-questionary-custom .p-xl-5 {
    padding: 3rem !important; }
  .tcpa-questionary-custom .pt-xl-5,
  .tcpa-questionary-custom .py-xl-5 {
    padding-top: 3rem !important; }
  .tcpa-questionary-custom .pr-xl-5,
  .tcpa-questionary-custom .px-xl-5 {
    padding-right: 3rem !important; }
  .tcpa-questionary-custom .pb-xl-5,
  .tcpa-questionary-custom .py-xl-5 {
    padding-bottom: 3rem !important; }
  .tcpa-questionary-custom .pl-xl-5,
  .tcpa-questionary-custom .px-xl-5 {
    padding-left: 3rem !important; }
  .tcpa-questionary-custom .m-xl-n1 {
    margin: -0.25rem !important; }
  .tcpa-questionary-custom .mt-xl-n1,
  .tcpa-questionary-custom .my-xl-n1 {
    margin-top: -0.25rem !important; }
  .tcpa-questionary-custom .mr-xl-n1,
  .tcpa-questionary-custom .mx-xl-n1 {
    margin-right: -0.25rem !important; }
  .tcpa-questionary-custom .mb-xl-n1,
  .tcpa-questionary-custom .my-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .tcpa-questionary-custom .ml-xl-n1,
  .tcpa-questionary-custom .mx-xl-n1 {
    margin-left: -0.25rem !important; }
  .tcpa-questionary-custom .m-xl-n2 {
    margin: -0.5rem !important; }
  .tcpa-questionary-custom .mt-xl-n2,
  .tcpa-questionary-custom .my-xl-n2 {
    margin-top: -0.5rem !important; }
  .tcpa-questionary-custom .mr-xl-n2,
  .tcpa-questionary-custom .mx-xl-n2 {
    margin-right: -0.5rem !important; }
  .tcpa-questionary-custom .mb-xl-n2,
  .tcpa-questionary-custom .my-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .tcpa-questionary-custom .ml-xl-n2,
  .tcpa-questionary-custom .mx-xl-n2 {
    margin-left: -0.5rem !important; }
  .tcpa-questionary-custom .m-xl-n3 {
    margin: -1rem !important; }
  .tcpa-questionary-custom .mt-xl-n3,
  .tcpa-questionary-custom .my-xl-n3 {
    margin-top: -1rem !important; }
  .tcpa-questionary-custom .mr-xl-n3,
  .tcpa-questionary-custom .mx-xl-n3 {
    margin-right: -1rem !important; }
  .tcpa-questionary-custom .mb-xl-n3,
  .tcpa-questionary-custom .my-xl-n3 {
    margin-bottom: -1rem !important; }
  .tcpa-questionary-custom .ml-xl-n3,
  .tcpa-questionary-custom .mx-xl-n3 {
    margin-left: -1rem !important; }
  .tcpa-questionary-custom .m-xl-n4 {
    margin: -1.5rem !important; }
  .tcpa-questionary-custom .mt-xl-n4,
  .tcpa-questionary-custom .my-xl-n4 {
    margin-top: -1.5rem !important; }
  .tcpa-questionary-custom .mr-xl-n4,
  .tcpa-questionary-custom .mx-xl-n4 {
    margin-right: -1.5rem !important; }
  .tcpa-questionary-custom .mb-xl-n4,
  .tcpa-questionary-custom .my-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .tcpa-questionary-custom .ml-xl-n4,
  .tcpa-questionary-custom .mx-xl-n4 {
    margin-left: -1.5rem !important; }
  .tcpa-questionary-custom .m-xl-n5 {
    margin: -3rem !important; }
  .tcpa-questionary-custom .mt-xl-n5,
  .tcpa-questionary-custom .my-xl-n5 {
    margin-top: -3rem !important; }
  .tcpa-questionary-custom .mr-xl-n5,
  .tcpa-questionary-custom .mx-xl-n5 {
    margin-right: -3rem !important; }
  .tcpa-questionary-custom .mb-xl-n5,
  .tcpa-questionary-custom .my-xl-n5 {
    margin-bottom: -3rem !important; }
  .tcpa-questionary-custom .ml-xl-n5,
  .tcpa-questionary-custom .mx-xl-n5 {
    margin-left: -3rem !important; }
  .tcpa-questionary-custom .m-xl-auto {
    margin: auto !important; }
  .tcpa-questionary-custom .mt-xl-auto,
  .tcpa-questionary-custom .my-xl-auto {
    margin-top: auto !important; }
  .tcpa-questionary-custom .mr-xl-auto,
  .tcpa-questionary-custom .mx-xl-auto {
    margin-right: auto !important; }
  .tcpa-questionary-custom .mb-xl-auto,
  .tcpa-questionary-custom .my-xl-auto {
    margin-bottom: auto !important; }
  .tcpa-questionary-custom .ml-xl-auto,
  .tcpa-questionary-custom .mx-xl-auto {
    margin-left: auto !important; } }

.tcpa-questionary-custom .tcpa-item-image {
  width: 50px;
  height: 50px; }
`;

export default DEFAULT_CSS;
